import { AWS_CONFIG_TYPE } from '../../BaseUrl';
import { BUCKET_NAME, COLUMN_TRANSFORMATIONS } from '../../constants/Constant';
import { updatedSecretName } from '../../utils/metadataConstants';
import {
  DATA_QUALITY_AGENT,
  DATA_QUALITY_REPORT,
  DATA_QUALITY_RULES,
  DATA_QUALITY_RULES2,
  DEDUPLICATION_AGENT,
  FETCH_SCHEMA,
  LLM_DQ_RULES,
  LLM_DQ_RULES_2,
  LLM_MAPPER,
  READ_PDF_AZURE,
} from '../../utils/NodeModalContants';

export default function convertToRequiredFormat(getJobFromLocalStorage, track_id, workflow_id, sample_view = '') {
  const steps = [];
  let previous = true;
  let isAgentAvailable = false;
  let stepCount = 1;
  let read_object_boolean = false;
  let read_boolean = true;
  let read_object_index = 0;
  let read_object;
  const read_object_arr = [];

  let write_object;
  const write_object_arr = [];
  let write_object_boolean = false;
  const write_boolean = true;
  const handle_write_object_index = 0;

  let executeSQL_object_boolean = false;
  let executeSQL_boolean = true;
  let executeSQL_object_index = 0;
  let executeSQL_object;
  let execute_sql_object_arr = [];

  let cluster_object_boolean = false;
  let cluster_boolean = true;
  let cluster_object_index = 0;
  let cluster_object;
  let cluster_object_arr = [];

  let read_pdf_azure_object_boolean = false;
  let read_pdf_azure_boolean = true;
  // let read_pdf_azure_object_index = 0;
  let read_pdf_azure_object;
  const read_pdf_azure_object_arr = [];

  let segmentation_object_boolean = false;
  let segmentation_boolean = true;
  let segmentation_object_index = 0;
  let segmentation_object;
  let segmentation_object_arr = [];

  let prediction_object_boolean = false;
  let prediction_boolean = true;
  let prediction_object_index = 0;
  let prediction_object;
  let prediction_object_arr = [];

  let profiling_object_boolean = false;
  let profiling_boolean = true;
  let profiling_object_index = 0;
  let profiling_object;
  const profiling_object_arr = [];

  const SKIPPED_BLOCKS = {
    [DATA_QUALITY_REPORT.nodeModalTitle]: DATA_QUALITY_REPORT.jsonMethodName,
  };

  getJobFromLocalStorage &&
    getJobFromLocalStorage.map((ele) => {
      if (
        // ele.nodeName === 'Read' ||
        ele.nodeName === 'ReadCSV' ||
        ele.nodeName === 'ReadApi' ||
        ele.nodeName === 'ReadCSVAws' ||
        ele.nodeName === 'ReadCSVAzure' ||
        ele.nodeName === 'PdfDataExtractor' ||
        ele.nodeName === 'ReadCSVData' ||
        // ele.nodeName === 'DataQualityIssues' ||
        // ele.nodeName === 'DataQualityIssues2' ||
        ele.nodeName === 'VisualInsights' ||
        // ele.nodeName === 'CopyADLS' ||
        ele.nodeName === 'ReadPublishedData' ||
        ele.nodeName === 'ReadStreaming' ||
        ele.nodeName === 'ReadDelimited' ||
        ele.nodeName === 'ReadOracle' ||
        ele.nodeName === 'ReadOracleDB' ||
        ele.nodeName === 'ReadPostgres' ||
        ele.nodeName === 'ReadPostgres2' ||
        ele.nodeName === 'ReadDB2' ||
        ele.nodeName === 'ReadAuroraDB' ||
        ele.nodeName === 'ReadCosmos' ||
        ele.nodeName === 'ReadSQLServer' ||
        ele.nodeName === 'ReadMySql' ||
        ele.nodeName === 'ReadSnowflake' ||
        ele.nodeName === 'ReadSnowflake2' ||
        ele.nodeName === 'Read Real-Time' ||
        ele.nodeName === 'FileUploader'
      ) {
        if (read_object_boolean === false) {
          read_object = new Object();
          read_object['method_name'] = 'Read';
          if (ele.nodeName === 'ReadApi') {
            read_object['method_name'] = 'ReadApi';
          }
          read_object['params'] = new Object();
          read_object['params']['definitions'] = new Array();
          read_object_boolean = true;
        }

        read_object['params']['definitions'][read_object_index] = new Object();

        read_object['params']['definitions'][read_object_index]['step_name'] =
          ele.nodeName === 'ReadCSVData' ? `ReadCSV_${stepCount}` : `${ele.step_name}_${stepCount}`;

        read_object['params']['definitions'][read_object_index]['step_number'] = stepCount;
        read_object['params']['definitions'][read_object_index]['df'] = ele.formField.alias;
        read_object['params']['definitions'][read_object_index]['alias'] = ele.formField.alias;
        if (ele.nodeName === 'ReadSnowflake') {
          read_object['params']['definitions'][read_object_index]['format'] = 'snowflake';
        } else {
          read_object['params']['definitions'][read_object_index]['format'] = ele.formField.format;
        }
        if (ele.nodeName !== 'Read Real-Time') {
          read_object['params']['definitions'][read_object_index]['cdc'] = ele.formField.CDC;
        }

        read_object['params']['definitions'][read_object_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;

        if (track_id !== 'snowflake-garbageTID') {
          if (ele.nodeName !== 'Read Real-Time') {
            read_object['params']['definitions'][read_object_index]['DataProcessor_tracking_id'] = track_id;
          }
        }
        if (ele.formField.format === 'api') {
          read_object['params']['definitions'][read_object_index]['url'] = ele.formField.url;
          read_object['params']['definitions'][read_object_index]['token'] = JSON.parse(
            sessionStorage.getItem('jwtToken')
          );
        }
        if (ele.formField.format === 'delimeted') {
          const row_level_fields = [];

          if (ele.fetchedHeader.length > 0) {
            ele.fetchedHeader.forEach((el) => {
              row_level_fields.push({ fieldname: el.header });
            });
          }

          read_object['params']['definitions'][read_object_index]['row_operations'] = new Object();
          read_object['params']['definitions'][read_object_index]['row_operations']['ignoreblanklines'] =
            ele.formField.ignoreblanklines || false;
          read_object['params']['definitions'][read_object_index]['row_operations']['skipheaders'] =
            ele.formField.skipheaders || false;
          read_object['params']['definitions'][read_object_index]['row_operations']['columnshift'] =
            ele.formField.columnshift || false;
          read_object['params']['definitions'][read_object_index]['row_operations']['junkrecords'] =
            ele.formField.junkrecords || false;
          read_object['params']['definitions'][read_object_index]['row_operations']['linebreak'] =
            ele.formField.linebreak || false;
          read_object['params']['definitions'][read_object_index]['row_operations']['delimiter'] =
            ele.formField.delimiter;
          read_object['params']['definitions'][read_object_index]['row_operations']['fields'] = row_level_fields;
        }
        if (ele.nodeName !== 'Read Real-Time') {
          if (ele.nodeName === 'ReadSnowflake') {
            read_object['params']['definitions'][read_object_index]['delimiter'] = '';
          } else {
            read_object['params']['definitions'][read_object_index]['delimiter'] = ele.formField.delimiter;
          }
        }
        read_object['params']['definitions'][read_object_index]['distinct_rows'] = ele.formField.distinct_rows;
        read_object['params']['definitions'][read_object_index]['sample_view'] = ele.formField.sample_view;
        if (ele.nodeName !== 'Read Real-Time') {
          if (ele.nodeName === 'ReadPublishedData') {
            const url = ele.formField.path;
            const newPath = url.replace(/\/([^/]+)$/, '');
            read_object['params']['definitions'][read_object_index]['path'] = newPath;
          } else if (ele.formField.path) {
            read_object['params']['definitions'][read_object_index]['path'] = ele.formField.path;
          } else if (ele.nodeName === 'ReadCosmos') {
            read_object['params']['definitions'][read_object_index]['database'] = ele.formField.database;
            read_object['params']['definitions'][read_object_index]['container'] = ele.formField.schema;
          } else if (ele.nodeName === 'ReadSnowflake') {
            read_object['params']['definitions'][read_object_index]['database'] = ele.formField.database;
            read_object['params']['definitions'][read_object_index]['schema'] = ele.formField.schema;
            read_object['params']['definitions'][read_object_index]['tablename'] = ele.formField.tablename;
          } else {
            read_object['params']['definitions'][read_object_index]['database'] = ele.formField.database;
            read_object['params']['definitions'][read_object_index]['tablename'] = ele.formField.tablename;
            read_object['params']['definitions'][read_object_index]['schema'] = ele.formField.schema;
          }
        }
        if (ele.nodeName !== 'Read Real-Time') {
          if (ele.formField.persist === true) {
            read_object['params']['definitions'][read_object_index]['persist_type'] = ele.formField.persist_type;
          } else {
            read_object['params']['definitions'][read_object_index]['persist_type'] = '';
          }
          read_object['params']['definitions'][read_object_index]['pagination'] = ele.formField.pagination || false;
          if (ele.formField.pagination) {
            read_object['params']['definitions'][read_object_index]['partitionColumn'] = ele.formField.partitionColumn;
            read_object['params']['definitions'][read_object_index]['numPartitions'] = ele.formField.numPartitions;
            read_object['params']['definitions'][read_object_index]['lowerBound'] = ele.formField.lowerBound;
            read_object['params']['definitions'][read_object_index]['upperBound'] = ele.formField.upperBound;
          }
        }
        if (ele.nodeName === 'ReadCSVAws') {
          read_object['params']['definitions'][read_object_index]['connection_type'] = ele.formField.connection_type;
          read_object['params']['definitions'][read_object_index]['secret_name'] = updatedSecretName(
            's3',
            ele.formField.secret_name
          );
        }
        if (ele.nodeName === 'ReadSnowflake2') {
          read_object['params']['definitions'][read_object_index]['connection_type'] = ele.formField.connection_type;
          read_object['params']['definitions'][read_object_index]['secret_name'] = updatedSecretName(
            'snowflake',
            ele.formField.secret_name
          );
        }
        if (ele.nodeName === 'ReadPostgres2') {
          read_object['params']['definitions'][read_object_index]['connection_type'] = ele.formField.connection_type;
          read_object['params']['definitions'][read_object_index]['secret_name'] = updatedSecretName(
            'postgresql',
            ele.formField.secret_name
          );
        }
        if (ele.nodeName === 'ReadSQLServer') {
          read_object['params']['definitions'][read_object_index]['connection_type'] = ele.formField.connection_type;
          read_object['params']['definitions'][read_object_index]['secret_name'] = updatedSecretName(
            'sqlserver',
            ele.formField.secret_name
          );
        }

        if (ele.nodeName === 'ReadOracleDB') {
          read_object['params']['definitions'][read_object_index]['connection_type'] = ele.formField.connection_type;
          read_object['params']['definitions'][read_object_index]['secret_name'] = updatedSecretName(
            'oracle',
            ele.formField.secret_name
          );
        }

        if (ele.nodeName === 'ReadCSVAzure') {
          read_object['params']['definitions'][read_object_index]['connection_type'] = ele.formField.connection_type;
          read_object['params']['definitions'][read_object_index]['secret_name'] = updatedSecretName(
            'adls',
            ele.formField.secret_name
          );
        }

        if (ele.nodeName === 'Read Real-Time') {
          read_object['params']['definitions'][read_object_index]['host'] = ele.formField.host;
          read_object['params']['definitions'][read_object_index]['topic'] = ele.formField.topic;
          read_object['params']['definitions'][read_object_index]['path_json'] = ele.formField.path;
          read_object['params']['definitions'][read_object_index]['step_name'] = `Read_${stepCount}`;
        }
        read_object['params']['definitions'][read_object_index]['action'] = ele.formField.action
          ? ele.formField.action
          : '';

        const newArray = [];
        const header_list = [];
        if (ele.headerName.length > 0) {
          ele.headerName.forEach((el) => {
            const updatedHeader = el?.header?.includes('.') ? `\`${el.header}\`` : `${el.header}`;
            header_list.push(updatedHeader);
            if (el.alias && el.cast_datatype !== 'string' && !el.default_value) {
              newArray.push(`cast(${updatedHeader} as ${el.cast_datatype}) as ${el.alias}`);
            } else if (!el.alias && el.cast_datatype !== 'string' && !el.default_value) {
              newArray.push(`cast(${updatedHeader} as ${el.cast_datatype})`);
            } else if (el.alias && el.cast_datatype === 'string' && !el.default_value) {
              newArray.push(`${updatedHeader} as ${el.alias}`);
            } else if (el.alias && el.cast_datatype !== 'string' && el.default_value) {
              newArray.push(
                `cast(${el.attribute_type === 'static' ? `'${el.default_value}'` : el.default_value} as ${
                  el.cast_datatype
                }) as ${el.alias}`
              );
            } else if (!el.alias && el.cast_datatype !== 'string' && el.default_value) {
              newArray.push(
                `cast(${el.attribute_type === 'static' ? `'${el.default_value}'` : el.default_value} as ${
                  el.cast_datatype
                })`
              );
            } else if (!el.alias && el.cast_datatype === 'string' && el.default_value) {
              newArray.push(
                `${el.attribute_type === 'static' ? `'${el.default_value}'` : el.default_value} as ${updatedHeader}`
              );
            } else {
              newArray.push(updatedHeader);
            }
          });
          if (ele.nodeName === 'AutomaticRuleGenerator') {
            read_object['params']['definitions'][read_object_index]['col_list'] = header_list;
          } else {
            read_object['params']['definitions'][read_object_index]['select_cols'] = newArray.toString();
          }
        }

        read_object['params']['definitions'][read_object_index]['action'] = ele.formField.action
          ? ele.formField.action
          : '';

        read_object_index++;
        read_object_arr.push(read_object);
        if (read_boolean) {
          steps.push(read_object_arr[0]);
          read_boolean = false;
        }
        stepCount++;
        previous = true;
      } else if (ele.nodeName === READ_PDF_AZURE.nodeModalTitle) {
        if (!read_pdf_azure_object_boolean) {
          // Initialize read_pdf_azure_object once if not already done
          read_pdf_azure_object = {
            method_name: READ_PDF_AZURE.jsonMethodName,
            params: {
              definitions: [],
            },
          };
          read_pdf_azure_object_boolean = true;
        }

        const newPDFObject = {
          step_name: `${READ_PDF_AZURE.jsonMethodName}_${stepCount}`,
          step_number: stepCount,
          node_id: `${ele.nodeId}__${workflow_id}`,
          df: ele.formField.alias,
          format: 'pdf',
          distinct_rows: false,
          sample_view: ele.formField.sample_view,
          path: ele.formField.path,
          page_range: ele.formField.page_range,
        };

        // Add newPDFObject directly to definitions array
        read_pdf_azure_object.params.definitions.push(newPDFObject);

        // Add the current read_pdf_azure_object to read_pdf_azure_object_arr if needed
        if (read_pdf_azure_boolean) {
          read_pdf_azure_object_arr.push(read_pdf_azure_object);
          steps.push(read_pdf_azure_object); // Add to steps if required
          read_pdf_azure_boolean = false;
        }

        // Increment step count and set previous flag as done
        stepCount++;
        previous = true;
      } else if (ele.nodeName === FETCH_SCHEMA.nodeModalTitle) {
        const fetch_schema = new Object();
        fetch_schema['method_name'] = FETCH_SCHEMA.jsonMethodName;
        fetch_schema['params'] = new Object();
        fetch_schema['params']['definitions'] = new Array();
        const fetch_schema_index = 0;
        fetch_schema['params']['definitions'][fetch_schema_index] = new Object();
        fetch_schema['params']['definitions'][fetch_schema_index]['step_name'] = FETCH_SCHEMA.jsonMethodName;
        fetch_schema['params']['definitions'][fetch_schema_index]['step_number'] = stepCount;
        fetch_schema['params']['definitions'][fetch_schema_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        fetch_schema['params']['definitions'][fetch_schema_index]['tablename'] = ele.formField.tablename;

        stepCount++;
        steps.push(fetch_schema);
        previous = false;
      } else if (ele.nodeName === LLM_MAPPER.nodeModalTitle) {
        const llm_mapper = new Object();
        llm_mapper['method_name'] = LLM_MAPPER.jsonMethodName;
        llm_mapper['params'] = new Object();
        llm_mapper['params']['definitions'] = new Array();
        const llm_mapper_index = 0;

        llm_mapper['params']['definitions'][llm_mapper_index] = new Object();
        llm_mapper['params']['definitions'][llm_mapper_index]['step_name'] = LLM_MAPPER.jsonMethodName;
        llm_mapper['params']['definitions'][llm_mapper_index]['step_number'] = stepCount;
        llm_mapper['params']['definitions'][llm_mapper_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        llm_mapper['params']['definitions'][llm_mapper_index]['sample_view'] = true;
        llm_mapper['params']['definitions'][llm_mapper_index]['format'] = 'csv';
        llm_mapper['params']['definitions'][llm_mapper_index]['df'] = ele.formField.df;
        llm_mapper['params']['definitions'][llm_mapper_index]['overwrite'] = true;
        llm_mapper['params']['definitions'][llm_mapper_index]['alias'] = ele.formField.alias;
        llm_mapper['params']['definitions'][llm_mapper_index]['mappings'] = new Array();
        llm_mapper['params']['definitions'][llm_mapper_index]['mappings'] = ele.formField.mappings;

        stepCount++;
        steps.push(llm_mapper);
        previous = false;
      } else if (ele.nodeName === 'DataModel') {
        const dataMapperObj = {
          method_name: 'DataModel',
          params: {
            definitions: [
              {
                step_name: 'DataModel_1',
                step_number: stepCount,
                df: ele.formField.df,
                alias: ele.formField.alias,
                node_id: `${ele.nodeId}__${workflow_id}`,
                entity_id: ele.formField.entity_id,
              },
            ],
          },
        };
        stepCount++;
        steps.push(dataMapperObj);
        previous = false;
      } else if (ele.nodeName === 'Cleanse') {
        const cleanseObj = {
          method_name: 'DataCleansing',
          params: {
            definitions: [
              {
                step_name: 'Cleanse_1',
                step_number: stepCount,
                df: ele.formField.df,
                alias: ele.formField.alias,
                node_id: `${ele.nodeId}__${workflow_id}`,
                entity_id: ele.formField.entity_id,
              },
            ],
          },
        };
        stepCount++;
        steps.push(cleanseObj);
        previous = false;
      } else if (ele.nodeName === 'Match') {
        const matchObj = {
          method_name: 'Dedupe_V1',
          params: {
            definitions: [
              {
                step_name: 'dedupe_V1_1',
                step_number: stepCount,
                df: ele.formField.df,
                alias: ele.formField.alias,
                node_id: `${ele.nodeId}__${workflow_id}`,
                entity_id: ele.formField.entity_id,
              },
            ],
          },
        };
        stepCount++;
        steps.push(matchObj);
        previous = false;
      } else if (ele.nodeName === 'Survivorship') {
        const matchObj = {
          method_name: 'Survivorship',
          params: {
            definitions: [
              {
                step_name: 'Survivorship_1',
                step_number: stepCount,
                df: ele.formField.df,
                alias: ele.formField.alias,
                node_id: `${ele.nodeId}__${workflow_id}`,
                entity_id: ele.formField.entity_id,
              },
            ],
          },
        };
        stepCount++;
        steps.push(matchObj);
        previous = false;
      } else if (ele.nodeName === 'AddColumn') {
        const colOject = new Object();
        colOject['method_name'] = 'AddColumn';
        colOject['params'] = new Object();
        colOject['params']['definitions'] = new Array();
        const col_index = 0;

        colOject['params']['definitions'][col_index] = new Object();
        colOject['params']['definitions'][col_index]['step_name'] = 'addColumn';
        colOject['params']['definitions'][col_index]['step_number'] = stepCount;
        colOject['params']['definitions'][col_index]['df'] = ele.formField.df;
        colOject['params']['definitions'][col_index]['db_name'] = 'default';
        colOject['params']['definitions'][col_index]['alias'] = ele.formField.alias;
        colOject['params']['definitions'][col_index]['action'] = '';
        colOject['params']['definitions'][col_index]['persist'] = false;
        colOject['params']['definitions'][col_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        colOject['params']['definitions'][col_index]['sample_view'] = ele.formField.sample_view;
        colOject['params']['definitions'][col_index]['addition_columns_array'] = ele.formField.addition_columns_array;

        stepCount++;
        steps.push(colOject);
        previous = false;
      } else if (ele.nodeName === 'DeleteColumn') {
        const colOject = new Object();
        colOject['method_name'] = 'DeleteColumn';
        colOject['params'] = new Object();
        colOject['params']['definitions'] = new Array();
        const col_index = 0;

        colOject['params']['definitions'][col_index] = new Object();
        colOject['params']['definitions'][col_index]['step_name'] = 'DeleteColumn';
        colOject['params']['definitions'][col_index]['step_number'] = stepCount;
        colOject['params']['definitions'][col_index]['df'] = ele.formField.df;
        colOject['params']['definitions'][col_index]['db_name'] = 'default';
        colOject['params']['definitions'][col_index]['alias'] = ele.formField.alias;
        colOject['params']['definitions'][col_index]['action'] = '';
        colOject['params']['definitions'][col_index]['persist'] = false;
        colOject['params']['definitions'][col_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        colOject['params']['definitions'][col_index]['sample_view'] = ele.formField.sample_view;
        colOject['params']['definitions'][col_index]['column_indices'] = ele.formField.column_indices;

        stepCount++;
        steps.push(colOject);
        previous = false;
      } else if (ele.nodeName === LLM_DQ_RULES.nodeModalTitle) {
        const llm_dq_rules = new Object();
        llm_dq_rules['method_name'] = LLM_DQ_RULES.jsonMethodName;
        llm_dq_rules['params'] = new Object();
        llm_dq_rules['params']['definitions'] = new Array();
        const llm_dq_rules_index = 0;

        llm_dq_rules['params']['definitions'][llm_dq_rules_index] = new Object();
        llm_dq_rules['params']['definitions'][llm_dq_rules_index]['step_name'] = LLM_DQ_RULES.jsonMethodName;
        llm_dq_rules['params']['definitions'][llm_dq_rules_index]['step_number'] = stepCount;
        llm_dq_rules['params']['definitions'][llm_dq_rules_index]['df'] = ele.formField.df;
        llm_dq_rules['params']['definitions'][llm_dq_rules_index]['alias'] = ele.formField.alias;
        llm_dq_rules['params']['definitions'][llm_dq_rules_index]['metric'] = ele.formField.metric;
        llm_dq_rules['params']['definitions'][llm_dq_rules_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        const dqRuleList = ele.formField.dqRules.filter((dqRule) => dqRule.isChecked);
        llm_dq_rules['params']['definitions'][llm_dq_rules_index]['rule_list'] = dqRuleList;

        stepCount++;
        steps.push(llm_dq_rules);
        previous = false;
      }
      else if (ele.nodeName === LLM_DQ_RULES_2.nodeModalTitle) {
        const llm_dq_rules2 = new Object();
        llm_dq_rules2['method_name'] = LLM_DQ_RULES_2.jsonMethodName;
        llm_dq_rules2['params'] = new Object();
        llm_dq_rules2['params']['definitions'] = new Array();
        const llm_dq_rules_index = 0;

        llm_dq_rules2['params']['definitions'][llm_dq_rules_index] = new Object();
        llm_dq_rules2['params']['definitions'][llm_dq_rules_index]['step_name'] = LLM_DQ_RULES_2.jsonMethodName;
        llm_dq_rules2['params']['definitions'][llm_dq_rules_index]['step_number'] = stepCount;
        llm_dq_rules2['params']['definitions'][llm_dq_rules_index]['df'] = ele.formField.df;
        llm_dq_rules2['params']['definitions'][llm_dq_rules_index]['alias'] = ele.formField.alias;
        llm_dq_rules2['params']['definitions'][llm_dq_rules_index]['metric'] = ele.formField.metric;
        llm_dq_rules2['params']['definitions'][llm_dq_rules_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        const transformRuleList = (dqRules) =>
          dqRules
            .filter((rule) => rule.isChecked)
            .map(({ fields, ...rest }) => ({
              ...rest,
              fieldName: fields.map((f) => f.fieldName),
            }));

        llm_dq_rules2.params.definitions[llm_dq_rules_index].rule_list = transformRuleList(ele.formField.dqRules);

        stepCount++;
        steps.push(llm_dq_rules2);
        previous = false;
      }
       else if (ele.nodeName === 'Source') {
        const source_object = new Object();

        source_object['method_name'] = 'Read';
        source_object['params'] = new Object();

        const read_object = [];

        ele.fetchedHeader.forEach((item) => {
          const newReadObject = {
            step_name: `Read_${stepCount}`,
            step_number: stepCount,
            node_id: `${ele.nodeId}__${workflow_id}`,
            df: item.df,
            delimiter: ',',
            format: 'csv',
            distinct_rows: false,
            sample_view: ele.formField.sample_view,
            path: item.path,
            persist: false,
            persist_type: '',
            pagination: false,
            action: '',
            select_cols: '*',
          };
          stepCount++;
          read_object.push(newReadObject);
        });

        source_object['params']['definitions'] = read_object;

        steps.push(source_object);
        previous = true;
      } else if (ele.nodeName === 'Udf') {
        if (previous) {
          executeSQL_object_boolean = false;
          executeSQL_boolean = true;
          execute_sql_object_arr = [];
          executeSQL_object_index = 0;
        }
        // if (executeSQL_object_boolean === false) {
        executeSQL_object = new Object();
        executeSQL_object['method_name'] = 'ExecuteSQL';
        executeSQL_object['params'] = new Object();
        executeSQL_object['params']['definitions'] = new Array();
        executeSQL_object_boolean = true;
        // }
        executeSQL_object['params']['definitions'][executeSQL_object_index] = new Object();
        executeSQL_object['params']['definitions'][executeSQL_object_index][
          'step_name'
        ] = `${ele.step_name}_${stepCount}`;
        executeSQL_object['params']['definitions'][executeSQL_object_index]['step_number'] = stepCount;
        executeSQL_object['params']['definitions'][executeSQL_object_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        executeSQL_object['params']['definitions'][executeSQL_object_index]['df'] = ele.formField.alias;
        executeSQL_object['params']['definitions'][executeSQL_object_index]['db_name'] = ele.formField.db_name;
        executeSQL_object['params']['definitions'][executeSQL_object_index]['statement'] = ele.formField.statement;
        executeSQL_object['params']['definitions'][executeSQL_object_index]['persist'] = ele.formField.persist;
        executeSQL_object['params']['definitions'][executeSQL_object_index]['udf'] = ele.udfList;
        executeSQL_object['params']['definitions'][executeSQL_object_index]['sample_view'] = ele.formField.sample_view;
        executeSQL_object['params']['definitions'][executeSQL_object_index]['distinct_rows'] =
          ele.formField.distinct_rows;

        if (ele.formField.persist === true) {
          executeSQL_object['params']['definitions'][executeSQL_object_index]['persist_type'] =
            ele.formField.persist_type;
        } else {
          executeSQL_object['params']['definitions'][executeSQL_object_index]['persist_type'] = '';
        }
        executeSQL_object['params']['definitions'][executeSQL_object_index]['action'] = ele.formField.action
          ? ele.formField.action
          : '';
        // stepCount++;
        // executeSQL_object_index++;

        // execute_sql_object_arr.push(executeSQL_object);
        // // const new_execute_sql_object_arr = [...execute_sql_object_arr]

        // if (executeSQL_boolean) {
        //   steps.push(execute_sql_object_arr[0]);
        //   executeSQL_boolean = false;
        // }

        stepCount++;
        steps.push(executeSQL_object);
        previous = false;
      } else if (ele.nodeName === 'DataValidation') {
        const validation_object = new Object();
        let validation_object_index = 0;

        validation_object['method_name'] = 'DataValidation';
        validation_object['params'] = new Object();
        validation_object['params']['definitions'] = new Array();
        validation_object['params']['definitions'][validation_object_index] = new Object();
        validation_object['params']['definitions'][validation_object_index]['step_name'] = `Validate_${stepCount}`;
        validation_object['params']['definitions'][validation_object_index]['step_number'] = stepCount;
        validation_object['params']['definitions'][validation_object_index]['df'] = ele.formField.dataFrame;
        validation_object['params']['definitions'][validation_object_index]['alias'] = ele.formField.alias;
        validation_object['params']['definitions'][validation_object_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        validation_object['params']['definitions'][validation_object_index]['sample_view'] = ele.formField.sample_view;
        validation_object['params']['definitions'][validation_object_index]['persist'] = ele.formField.persist;
        validation_object['params']['definitions'][validation_object_index]['persist_type'] =
          ele.formField.persist_type;
        validation_object['params']['definitions'][validation_object_index]['action'] = ele.formField.action;
        validation_object['params']['definitions'][validation_object_index]['path_validation'] = ele.formField.path;
        validation_object['params']['definitions'][validation_object_index]['path_profiling'] =
          ele.formField.profilingPath;

        const expectations_details = [];
        const newCol = [...ele.headerName];

        newCol.map((item) => {
          if (item.validation_name !== '') {
            const data = {
              expectation_name: item.validation_name,
              column: item.column,
            };

            delete item['validation_name'];
            delete item['column'];

            let param;

            if (data.expectation_name === 'expect_column_values_to_be_between') {
              param = {
                expectation_name: data.expectation_name,
                args: {
                  column: data.column,
                  max_value: parseInt(item.max_value, 10),
                  min_value: parseInt(item.min_value, 10),
                },
              };
            } else if (data.expectation_name === 'expect_column_values_to_be_in_set') {
              param = {
                expectation_name: data.expectation_name,
                args: {
                  column: data.column,
                  value_set: item.value_set.split(','),
                },
              };
            } else {
              param = {
                expectation_name: data.expectation_name,
                args: { column: data.column, ...item },
              };
            }

            expectations_details.push(param);
          }
        });

        validation_object['params']['definitions'][validation_object_index]['expectations_details'] =
          expectations_details;

        steps.push(validation_object);
        stepCount++;
        validation_object_index++;
        previous = true;
      } else if (ele.nodeName === 'Datatype Conversion') {
        let datatype_conversion_object_index = 0;
        const datatype_conversion_object = new Object();

        datatype_conversion_object['method_name'] = 'CHANGE_DATA_TYPE';
        datatype_conversion_object['params'] = new Object();
        datatype_conversion_object['params']['definitions'] = new Array();

        datatype_conversion_object['params']['definitions'][datatype_conversion_object_index] = new Object();
        datatype_conversion_object['params']['definitions'][datatype_conversion_object_index][
          'step_name'
        ] = `change_data_type_${stepCount}`;
        datatype_conversion_object['params']['definitions'][datatype_conversion_object_index]['step_number'] =
          stepCount;
        datatype_conversion_object['params']['definitions'][datatype_conversion_object_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        datatype_conversion_object['params']['definitions'][datatype_conversion_object_index]['df'] = ele.formField.df;
        datatype_conversion_object['params']['definitions'][datatype_conversion_object_index]['db_name'] =
          ele.formField.db_name;
        datatype_conversion_object['params']['definitions'][datatype_conversion_object_index]['alias'] =
          ele.formField.alias;
        datatype_conversion_object['params']['definitions'][datatype_conversion_object_index]['sample_view'] =
          ele.formField.sample_view;

        const col_list = [];
        ele.fetchedHeader.forEach((el) => {
          if ((el.checked === 'true' || el.checked === true) && el.transform === 'true') {
            if (el.cast_datatype === 'timestamp') {
              col_list.push({ col_name: el.header, type: el.cast_datatype, timestamp_format: el.time_stamp_format });
            } else {
              col_list.push({ col_name: el.header, type: el.cast_datatype });
            }
          }
        });

        const columns = { col_list };
        datatype_conversion_object['params']['definitions'][datatype_conversion_object_index]['columns'] = columns;

        stepCount++;
        datatype_conversion_object_index++;
        steps.push(datatype_conversion_object);
        previous = true;
      } 
      else if (ele.nodeName === 'Date Time Feature') {
        let date_time_object_index = 0;
        const date_time_object = new Object();

        date_time_object['method_name'] = 'DATETIME_FEATURE';
        date_time_object['params'] = new Object();
        date_time_object['params']['definitions'] = new Array();

        date_time_object['params']['definitions'][date_time_object_index] = new Object();
        date_time_object['params']['definitions'][date_time_object_index][
          'step_name'
        ] = `datetime_feature_${stepCount}`;
        date_time_object['params']['definitions'][date_time_object_index]['step_number'] = stepCount;
        date_time_object['params']['definitions'][date_time_object_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        date_time_object['params']['definitions'][date_time_object_index]['df'] = ele.formField.df;
        date_time_object['params']['definitions'][date_time_object_index]['db_name'] = ele.formField.db_name;
        date_time_object['params']['definitions'][date_time_object_index]['alias'] = ele.formField.alias;
        date_time_object['params']['definitions'][date_time_object_index]['sample_view'] = ele.formField.sample_view;

        const col_list = [];
        ele.sorting.forEach((el) => {
          col_list.push({ output_col_name: el.alias, date_feature: el.date_feature, timestamp_col: el.attribute });
          // if (el.cast_datatype === 'timestamp') {
          //   col_list.push({ output_col_name: el.alias, date_feature: el.date_feature, timestamp_col: el.attribute });
          // } else {
          //   col_list.push({ output_col_name: el.alias, date_feature: el.date_feature, timestamp_col: el.attribute });
          // }
        });

        const columns = { col_list };
        date_time_object['params']['definitions'][date_time_object_index]['columns'] = columns;

        stepCount++;
        date_time_object_index++;
        steps.push(date_time_object);
        previous = true;
      } else if (ele.nodeName === 'Handle Null') {
        let handle_null_object_index = 0;
        const handle_null_object = new Object();

        handle_null_object['method_name'] = 'HANDLING_NULL_VALUES';
        handle_null_object['params'] = new Object();
        handle_null_object['params']['definitions'] = new Array();

        handle_null_object['params']['definitions'][handle_null_object_index] = new Object();
        handle_null_object['params']['definitions'][handle_null_object_index]['step_name'] = `handle_null_${stepCount}`;
        handle_null_object['params']['definitions'][handle_null_object_index]['step_number'] = stepCount;
        handle_null_object['params']['definitions'][handle_null_object_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        handle_null_object['params']['definitions'][handle_null_object_index]['df'] = ele.formField.df;
        handle_null_object['params']['definitions'][handle_null_object_index]['db_name'] = ele.formField.db_name;
        handle_null_object['params']['definitions'][handle_null_object_index]['alias'] = ele.formField.alias;
        handle_null_object['params']['definitions'][handle_null_object_index]['sample_view'] =
          ele.formField.sample_view;

        const col_list = [];
        ele.fetchedHeader.forEach((el) => {
          if ((el.checked === 'true' || el.checked === true) && el.transform === 'true') {
            if (el.handling_type === 'withsomevalue') {
              col_list.push({
                input_col_name: el.header,
                null_handling_type: el.handling_type,
                value: el.value,
                data_type: el.cast_datatype,
              });
            } else if (el.handling_type === 'impute_with_hmean_median_mode') {
              col_list.push({
                input_col_name: el.header,
                null_handling_type: el.handling_type,
                impute_stratergy: el.impute,
                data_type: el.cast_datatype,
              });
            } else {
              col_list.push({
                input_col_name: el.header,
                null_handling_type: el.handling_type,
                data_type: el.cast_datatype,
              });
            }
          }
        });

        const columns = { col_list };
        handle_null_object['params']['definitions'][handle_null_object_index]['columns'] = columns;

        stepCount++;
        handle_null_object_index++;
        steps.push(handle_null_object);
        previous = true;
      } else if (ele.nodeName === 'OneHot Encoder') {
        let onehot_encoder_object_index = 0;
        const onehot_encoder_object = new Object();

        onehot_encoder_object['method_name'] = 'ONEHOT_ENCODER';
        onehot_encoder_object['params'] = new Object();
        onehot_encoder_object['params']['definitions'] = new Array();

        onehot_encoder_object['params']['definitions'][onehot_encoder_object_index] = new Object();
        onehot_encoder_object['params']['definitions'][onehot_encoder_object_index][
          'step_name'
        ] = `onehot_encoder_${stepCount}`;
        onehot_encoder_object['params']['definitions'][onehot_encoder_object_index]['step_number'] = stepCount;
        onehot_encoder_object['params']['definitions'][onehot_encoder_object_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        onehot_encoder_object['params']['definitions'][onehot_encoder_object_index]['df'] = ele.formField.df;
        onehot_encoder_object['params']['definitions'][onehot_encoder_object_index]['db_name'] = ele.formField.db_name;
        onehot_encoder_object['params']['definitions'][onehot_encoder_object_index]['alias'] = ele.formField.alias;
        onehot_encoder_object['params']['definitions'][onehot_encoder_object_index]['sample_view'] =
          ele.formField.sample_view;

        const col_list = [];
        ele.fetchedHeader.forEach((el) => {
          if ((el.checked === 'true' || el.checked === true) && el.transform === 'true') {
            col_list.push({
              input_col_name: el.header,
              data_type: el.cast_datatype,
            });
          }
        });

        const columns = { col_list };
        onehot_encoder_object['params']['definitions'][onehot_encoder_object_index]['columns'] = columns;

        stepCount++;
        onehot_encoder_object_index++;
        steps.push(onehot_encoder_object);
        previous = true;
      } else if (ele.nodeName === 'StatisticalAggregation') {
        const colOject = new Object();
        colOject['method_name'] = 'StatisticalAggregation';
        colOject['params'] = new Object();
        colOject['params']['definitions'] = new Array();
        const col_index = 0;

        colOject['params']['definitions'][col_index] = new Object();
        colOject['params']['definitions'][col_index]['step_name'] = 'StatisticalAggregation';
        colOject['params']['definitions'][col_index]['step_number'] = stepCount;
        colOject['params']['definitions'][col_index]['df'] = ele.formField.df;
        colOject['params']['definitions'][col_index]['db_name'] = 'default';
        colOject['params']['definitions'][col_index]['alias'] = ele.formField.alias;
        colOject['params']['definitions'][col_index]['action'] = '';
        colOject['params']['definitions'][col_index]['persist'] = false;
        colOject['params']['definitions'][col_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        colOject['params']['definitions'][col_index]['sample_view'] = true;
        colOject['params']['definitions'][col_index]['aggregate_columns_array'] = ele.formField.aggregate_columns_array;

        stepCount++;
        steps.push(colOject);
        previous = false;
      } else if (COLUMN_TRANSFORMATIONS.includes(ele.nodeName)) {
        const colOject = new Object();
        colOject['method_name'] = 'DynamicColumnTransformation';
        colOject['params'] = new Object();
        colOject['params']['definitions'] = new Array();
        const col_index = 0;

        colOject['params']['definitions'][col_index] = new Object();
        colOject['params']['definitions'][col_index]['step_name'] = 'DynamicColumnTransformation';
        colOject['params']['definitions'][col_index]['step_number'] = stepCount;
        colOject['params']['definitions'][col_index]['df'] = ele.formField.df;
        colOject['params']['definitions'][col_index]['db_name'] = 'default';
        colOject['params']['definitions'][col_index]['alias'] = ele.formField.alias;
        colOject['params']['definitions'][col_index]['action'] = '';
        colOject['params']['definitions'][col_index]['persist'] = false;
        colOject['params']['definitions'][col_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        colOject['params']['definitions'][col_index]['sample_view'] = true;
        const transformed_array = [];
        ele.formField.transformations.map((transformation) => {
          console.log(ele.nodeName, ele.formField);
          const transformed_item = {
            type: ele.formField.type,
            output_column: transformation.outputColumn,
          };
          if (transformation.param) {
            transformed_item.params = transformation.param;
          } else if (transformation.params) {
            transformed_item.params = transformation.params;
          }

          if (transformation.sourceColumns) {
            if (Array.isArray(transformation.sourceColumns) && transformation.sourceColumns.length > 0) {
              transformed_item.columns = transformation.sourceColumns;
            } else if (typeof transformation.sourceColumns === 'string' && transformation.sourceColumns.trim() !== '') {
              transformed_item.columns = [transformation.sourceColumns];
            }
          }
          if (transformation.pad_len) {
            transformed_item.pad_len = transformation.pad_len;
          }
          if (transformation.transformInPlace && transformation.sourceColumns.length === 1) {
            transformed_item.output_column = transformation.sourceColumns[0];
          }
          transformed_array.push(transformed_item);
        });

        colOject['params']['definitions'][col_index]['transformations'] = transformed_array;
        stepCount++;
        steps.push(colOject);
        previous = false;
      } else if (ele.nodeName === 'CountBlock') {
        const colOject = new Object();
        colOject['method_name'] = 'Count';
        colOject['params'] = new Object();
        colOject['params']['definitions'] = new Array();
        const col_index = 0;

        colOject['params']['definitions'][col_index] = new Object();
        colOject['params']['definitions'][col_index]['step_name'] = 'count';
        colOject['params']['definitions'][col_index]['step_number'] = stepCount;
        colOject['params']['definitions'][col_index]['df'] = ele.formField.df;
        colOject['params']['definitions'][col_index]['db_name'] = 'default';
        colOject['params']['definitions'][col_index]['alias'] = ele.formField.alias;
        colOject['params']['definitions'][col_index]['action'] = '';
        colOject['params']['definitions'][col_index]['persist'] = false;
        colOject['params']['definitions'][col_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        colOject['params']['definitions'][col_index]['sample_view'] = true;
        stepCount++;
        steps.push(colOject);
        previous = false;
      } else if (ele.nodeName === 'DuplicacyCheck') {
        const colOject = new Object();
        colOject['method_name'] = 'DuplicacyCheck';
        colOject['params'] = new Object();
        colOject['params']['definitions'] = new Array();
        const col_index = 0;

        colOject['params']['definitions'][col_index] = new Object();
        colOject['params']['definitions'][col_index]['step_name'] = 'DuplicacyCheck';
        colOject['params']['definitions'][col_index]['step_number'] = stepCount;
        colOject['params']['definitions'][col_index]['df'] = ele.formField.df;
        colOject['params']['definitions'][col_index]['db_name'] = 'default';
        colOject['params']['definitions'][col_index]['alias'] = ele.formField.alias;
        colOject['params']['definitions'][col_index]['action'] = '';
        colOject['params']['definitions'][col_index]['persist'] = false;
        colOject['params']['definitions'][col_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        colOject['params']['definitions'][col_index]['sample_view'] = true;
        colOject['params']['definitions'][col_index]['columns_array'] = ele.formField.columns_array;
        stepCount++;
        steps.push(colOject);
        previous = false;
      } else if (ele.nodeName === 'SwapColumn') {
        const colOject = new Object();
        colOject['method_name'] = 'SwapColumn';
        colOject['params'] = new Object();
        colOject['params']['definitions'] = new Array();
        const col_index = 0;

        colOject['params']['definitions'][col_index] = new Object();
        colOject['params']['definitions'][col_index]['step_name'] = 'SwapColumn';
        colOject['params']['definitions'][col_index]['step_number'] = stepCount;
        colOject['params']['definitions'][col_index]['df'] = ele.formField.df;
        colOject['params']['definitions'][col_index]['db_name'] = 'default';
        colOject['params']['definitions'][col_index]['alias'] = ele.formField.alias;
        colOject['params']['definitions'][col_index]['action'] = '';
        colOject['params']['definitions'][col_index]['persist'] = false;
        colOject['params']['definitions'][col_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        colOject['params']['definitions'][col_index]['sample_view'] = true;
        colOject['params']['definitions'][col_index]['swap_columns_array'] = ele.formField.swap_columns_array;

        stepCount++;
        steps.push(colOject);
        previous = false;
      } else if (ele.nodeName === 'Label Encoder') {
        let label_encoder_object_index = 0;
        const label_encoder_object = new Object();

        label_encoder_object['method_name'] = 'LABEL_ENCODER';
        label_encoder_object['params'] = new Object();
        label_encoder_object['params']['definitions'] = new Array();

        label_encoder_object['params']['definitions'][label_encoder_object_index] = new Object();
        label_encoder_object['params']['definitions'][label_encoder_object_index][
          'step_name'
        ] = `label_encoder_${stepCount}`;
        label_encoder_object['params']['definitions'][label_encoder_object_index]['step_number'] = stepCount;
        label_encoder_object['params']['definitions'][label_encoder_object_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        label_encoder_object['params']['definitions'][label_encoder_object_index]['df'] = ele.formField.df;
        label_encoder_object['params']['definitions'][label_encoder_object_index]['db_name'] = ele.formField.db_name;
        label_encoder_object['params']['definitions'][label_encoder_object_index]['alias'] = ele.formField.alias;
        label_encoder_object['params']['definitions'][label_encoder_object_index]['sample_view'] =
          ele.formField.sample_view;

        const col_list = [];
        ele.fetchedHeader.forEach((el) => {
          if ((el.checked === 'true' || el.checked === true) && el.transform === 'true') {
            col_list.push({
              input_col_name: el.header,
              output_col_name: el.output_column,
              data_type: el.cast_datatype,
            });
          }
        });

        const columns = { col_list };
        label_encoder_object['params']['definitions'][label_encoder_object_index]['columns'] = columns;

        stepCount++;
        label_encoder_object_index++;
        steps.push(label_encoder_object);
        previous = true;
      } else if (ele.nodeName === 'Drop') {
        let drop_object_index = 0;
        const drop_object = new Object();

        drop_object['method_name'] = 'DROP';
        drop_object['params'] = new Object();
        drop_object['params']['definitions'] = new Array();

        drop_object['params']['definitions'][drop_object_index] = new Object();
        drop_object['params']['definitions'][drop_object_index]['step_name'] = `drop_${stepCount}`;
        drop_object['params']['definitions'][drop_object_index]['step_number'] = stepCount;
        drop_object['params']['definitions'][drop_object_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        drop_object['params']['definitions'][drop_object_index]['df'] = ele.formField.df;
        drop_object['params']['definitions'][drop_object_index]['db_name'] = ele.formField.db_name;
        drop_object['params']['definitions'][drop_object_index]['alias'] = ele.formField.alias;
        drop_object['params']['definitions'][drop_object_index]['sample_view'] = ele.formField.sample_view;

        const col_list = [];
        ele.fetchedHeader.forEach((el) => {
          if ((el.checked === 'true' || el.checked === true) && el.transform === 'true') {
            col_list.push({
              input_col_name: el.header,
            });
          }
        });

        const columns = { col_list };
        drop_object['params']['definitions'][drop_object_index]['columns'] = columns;

        stepCount++;
        drop_object_index++;
        steps.push(drop_object);
        previous = true;
      } else if (ele.nodeName === 'Outlier') {
        let outlier_object_index = 0;
        const outlier_object = new Object();

        outlier_object['method_name'] = 'OUTLIER';
        outlier_object['params'] = new Object();
        outlier_object['params']['definitions'] = new Array();

        outlier_object['params']['definitions'][outlier_object_index] = new Object();
        outlier_object['params']['definitions'][outlier_object_index]['step_name'] = `outlier_${stepCount}`;
        outlier_object['params']['definitions'][outlier_object_index]['step_number'] = stepCount;
        outlier_object['params']['definitions'][outlier_object_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        outlier_object['params']['definitions'][outlier_object_index]['df'] = ele.formField.df;
        outlier_object['params']['definitions'][outlier_object_index]['db_name'] = ele.formField.db_name;
        outlier_object['params']['definitions'][outlier_object_index]['alias'] = ele.formField.alias;
        outlier_object['params']['definitions'][outlier_object_index]['sample_view'] = ele.formField.sample_view;

        const col_list = [];
        ele.fetchedHeader.forEach((el) => {
          if ((el.checked === 'true' || el.checked === true) && el.transform === 'true') {
            if (el.outlier_stratergy === '') {
              col_list.push({
                input_col_name: el.header,
                outlier_type: el.outlier_type,
              });
            } else {
              col_list.push({
                input_col_name: el.header,
                outlier_type: el.outlier_type,
                outlier_stratergy: el.outlier_stratergy,
              });
            }
          }
        });

        const columns = { col_list };
        outlier_object['params']['definitions'][outlier_object_index]['columns'] = columns;

        stepCount++;
        outlier_object_index++;
        steps.push(outlier_object);
        previous = true;
      } else if (ele.nodeName === 'Imbalanced Data') {
        let imbalanced_data_object_index = 0;
        const imbalanced_data_object = new Object();

        imbalanced_data_object['method_name'] = 'HANDEL_IMBALANCED_DATA';
        imbalanced_data_object['params'] = new Object();
        imbalanced_data_object['params']['definitions'] = new Array();

        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index] = new Object();
        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index][
          'step_name'
        ] = `imbalanced_data_${stepCount}`;
        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index]['step_number'] = stepCount;
        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index]['df'] = ele.formField.df;
        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index]['db_name'] =
          ele.formField.db_name;
        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index]['alias'] = ele.formField.alias;
        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index]['sample_view'] =
          ele.formField.sample_view;

        const col_list = [];
        ele.fetchedHeader.forEach((el) => {
          if ((el.checked === 'true' || el.checked === true) && el.transform === 'true') {
            col_list.push({
              input_col_name: el.header,
              majority_class: el.majority_class,
              minority_class: el.minority_class,
              ratio: el.ratio,
              type_of_sampling: el.type_of_sampling,
            });
          }
        });

        const columns = { col_list };
        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index]['columns'] = columns;

        stepCount++;
        imbalanced_data_object_index++;
        steps.push(imbalanced_data_object);
        previous = true;
      } else if (ele.nodeName === 'Imbalanced Data Sampling') {
        let imbalanced_data_object_index = 0;
        const imbalanced_data_object = new Object();

        imbalanced_data_object['method_name'] = 'IMBALANCED_DATA_SAMPLING';
        imbalanced_data_object['params'] = new Object();
        imbalanced_data_object['params']['definitions'] = new Array();

        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index] = new Object();
        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index][
          'step_name'
        ] = `imbalanced_data_${stepCount}`;
        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index]['step_number'] = stepCount;
        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index]['df'] = ele.formField.df;
        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index]['db_name'] =
          ele.formField.db_name;
        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index]['alias'] = ele.formField.alias;
        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index]['sample_view'] =
          ele.formField.sample_view;
        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index]['type_sampling'] =
          ele.formField.dataTypeRead;
        imbalanced_data_object['params']['definitions'][imbalanced_data_object_index]['target_col'] =
          ele.formField.column;

        stepCount++;
        imbalanced_data_object_index++;
        steps.push(imbalanced_data_object);
        previous = true;
      } 
       else if (ele.nodeName === 'Scaler') {
        let scaler_object_index = 0;
        const scaler_object = new Object();

        scaler_object['method_name'] = 'SCALER';
        scaler_object['params'] = new Object();
        scaler_object['params']['definitions'] = new Array();

        scaler_object['params']['definitions'][scaler_object_index] = new Object();
        scaler_object['params']['definitions'][scaler_object_index]['step_name'] = `scaler_${stepCount}`;
        scaler_object['params']['definitions'][scaler_object_index]['step_number'] = stepCount;
        scaler_object['params']['definitions'][scaler_object_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        scaler_object['params']['definitions'][scaler_object_index]['df'] = ele.formField.df;
        scaler_object['params']['definitions'][scaler_object_index]['db_name'] = ele.formField.db_name;
        scaler_object['params']['definitions'][scaler_object_index]['alias'] = ele.formField.alias;
        scaler_object['params']['definitions'][scaler_object_index]['sample_view'] = ele.formField.sample_view;

        const col_list = [];
        ele.fetchedHeader.forEach((el) => {
          if ((el.checked === 'true' || el.checked === true) && el.transform === 'true') {
            col_list.push({
              input_col_name: el.header,
              output_col_name: el.output_column,
              Scaler_type: el.Scaler_type,
              input_col_drop: el.input_col_drop,
            });
          }
        });

        const columns = { col_list };
        scaler_object['params']['definitions'][scaler_object_index]['columns'] = columns;

        stepCount++;
        scaler_object_index++;
        steps.push(scaler_object);
        previous = true;
      } else if (ele.nodeName === 'Resample') {
        let resample_object_index = 0;
        const resample_object = new Object();

        resample_object['method_name'] = 'RESAMPLE';
        resample_object['params'] = new Object();
        resample_object['params']['definitions'] = new Array();

        resample_object['params']['definitions'][resample_object_index] = new Object();
        resample_object['params']['definitions'][resample_object_index]['step_name'] = `resample_${stepCount}`;
        resample_object['params']['definitions'][resample_object_index]['step_number'] = stepCount;
        resample_object['params']['definitions'][resample_object_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        resample_object['params']['definitions'][resample_object_index]['df'] = ele.formField.df;
        resample_object['params']['definitions'][resample_object_index]['db_name'] = ele.formField.db_name;
        resample_object['params']['definitions'][resample_object_index]['alias'] = ele.formField.alias;
        resample_object['params']['definitions'][resample_object_index]['sample_view'] = ele.formField.sample_view;

        const col_list = [];
        ele.fetchedHeader.forEach((el) => {
          if ((el.checked === 'true' || el.checked === true) && el.transform === 'true') {
            col_list.push({
              timestamp_column_name: el.header,
              time_frame_window: el.time_frame_window,
              aggregation_function: el.aggregation_function,
              column_name: el.output_column,
            });
          }
        });

        const columns = { col_list };
        resample_object['params']['definitions'][resample_object_index]['columns'] = columns;

        stepCount++;
        resample_object_index++;
        steps.push(resample_object);
        previous = true;
      } else if (ele.nodeName === 'Training') {
        let handle_training_object_index = 0;
        const handle_training_object = new Object();

        handle_training_object['method_name'] = 'MULTI_MODEL_TRAIN';
        handle_training_object['params'] = new Object();
        handle_training_object['params']['definitions'] = new Array();

        handle_training_object['params']['definitions'][handle_training_object_index] = new Object();
        handle_training_object['params']['definitions'][handle_training_object_index][
          'step_name'
        ] = `train_${stepCount}`;
        handle_training_object['params']['definitions'][handle_training_object_index]['step_number'] = stepCount;
        handle_training_object['params']['definitions'][handle_training_object_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        handle_training_object['params']['definitions'][handle_training_object_index]['df'] = ele.formField.df;
        handle_training_object['params']['definitions'][handle_training_object_index]['alias'] = ele.formField.alias;
        handle_training_object['params']['definitions'][handle_training_object_index]['savePath'] = ele.formField.path;
        handle_training_object['params']['definitions'][handle_training_object_index]['sample_view'] =
          ele.formField.sample_view;

        const targetCol = {};
        const algorithmArr = [];
        let token = '';

        const split_ratio = {
          train: ele.formField.train,
          test: ele.formField.test,
          seed: ele.formField.seed,
        };

        if (ele.formField.algorithm === 'LinearRegression' || ele.formField.algorithm === 'LogisticRegression') {
          algorithmArr.push({
            maxIter: ele.formField.maxIter,
            regParam: ele.formField.regParam,
            elasticNetParam: ele.formField.elasticNetParam,
          });
        } else if (ele.formField.algorithm === 'RandomForestRegressor') {
          algorithmArr.push({
            numTrees: ele.formField.numTrees,
            maxDepth: ele.formField.maxDepth,
          });
        } else if (ele.formField.algorithm === 'SVM') {
          algorithmArr.push({
            maxIter: ele.formField.maxIter,
            regParam: ele.formField.regParam,
          });
        } else if (ele.formField.algorithm === 'KMeans' || ele.formField.algorithm === 'LDA') {
          algorithmArr.push({
            k: ele.formField.k,
            maxIter: ele.formField.maxIter,
          });
        } else if (ele.formField.algorithm === 'ALS') {
          algorithmArr.push({
            maxIter: ele.formField.maxIter,
            regParam: ele.formField.regParam,
            rank: ele.formField.rank,
          });
        }

        const algo_type = {
          [ele.formField.algo_type]: {
            [ele.formField.algorithm]: algorithmArr,
          },
        };
        const feature_list = [];
        ele.headerName.forEach((el) => {
          if (el.col_type !== 'target Col' && (el.checked === 'true' || el.checked === true)) {
            feature_list.push({
              col_name: el.header,
              type: el.cast_datatype,
            });
          } else {
            targetCol['col_name'] = el.header;
            targetCol['type'] = el.cast_datatype;
          }
        });

        const ratingCol = {};
        const userCol = {};
        const itemCol = {};

        ele.headerName.forEach((el) => {
          if (
            el.col_type !== 'user col' &&
            (el.checked === 'true' || el.checked === true) &&
            el.col_type !== 'item col' &&
            (el.checked === 'true' || el.checked === true)
          ) {
            ratingCol['col_name'] = el.header;
            ratingCol['type'] = el.cast_datatype;
          } else if (
            el.col_type !== 'rating col' &&
            (el.checked === 'true' || el.checked === true) &&
            el.col_type !== 'item col' &&
            (el.checked === 'true' || el.checked === true)
          ) {
            userCol['col_name'] = el.header;
            userCol['type'] = el.cast_datatype;
          } else if (
            el.col_type !== 'rating col' &&
            (el.checked === 'true' || el.checked === true) &&
            el.col_type !== 'user col' &&
            (el.checked === 'true' || el.checked === true)
          ) {
            itemCol['col_name'] = el.header;
            itemCol['type'] = el.cast_datatype;
          }
        });

        token = `${ele.formField.algo_type}-${ele.formField.algorithm}`;
        const features = { feature_list };
        const users = { userCol };
        const items = { itemCol };
        if (ele.formField.algo_type === 'recommendation' && ele.formField.algorithm === 'ALS') {
          handle_training_object['params']['definitions'][handle_training_object_index]['userCol'] = userCol;
          handle_training_object['params']['definitions'][handle_training_object_index]['ratingCol'] = ratingCol;
          handle_training_object['params']['definitions'][handle_training_object_index]['itemCol'] = itemCol;
        } else {
          handle_training_object['params']['definitions'][handle_training_object_index]['features'] = features;
          handle_training_object['params']['definitions'][handle_training_object_index]['targetCol'] = targetCol;
        }
        handle_training_object['params']['definitions'][handle_training_object_index]['algo_type'] = algo_type;
        handle_training_object['params']['definitions'][handle_training_object_index]['split_ratio'] = split_ratio;
        handle_training_object['params']['definitions'][handle_training_object_index]['token'] = token;

        stepCount++;
        handle_training_object_index++;
        steps.push(handle_training_object);
        previous = true;
      } else if (ele.nodeName === 'Profiling') {
        if (profiling_object_boolean === false) {
          profiling_object = new Object();
          profiling_object['method_name'] = 'DataProfiling';
          profiling_object['params'] = new Object();
          profiling_object['params']['definitions'] = new Array();
          profiling_object_boolean = true;
        }

        profiling_object['params']['definitions'][profiling_object_index] = new Object();
        profiling_object['params']['definitions'][profiling_object_index]['step_name'] = `Profile_${stepCount}`;
        profiling_object['params']['definitions'][profiling_object_index]['step_number'] = stepCount;
        profiling_object['params']['definitions'][profiling_object_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        profiling_object['params']['definitions'][profiling_object_index]['df'] = ele.formField.dataFrame;
        profiling_object['params']['definitions'][profiling_object_index]['alias'] = ele.formField.alias;
        profiling_object['params']['definitions'][profiling_object_index]['path_profiling'] =
          ele.formField.profilingPath;
        profiling_object['params']['definitions'][profiling_object_index]['path_expectations'] =
          ele.formField.expectationsPath;
        profiling_object['params']['definitions'][profiling_object_index]['action'] = ele.formField.action
          ? ele.formField.action
          : '';
        profiling_object['params']['definitions'][profiling_object_index]['sample_view'] = ele.formField.sample_view;
        profiling_object['params']['definitions'][profiling_object_index]['persist'] = ele.formField.persist;

        if (ele.formField.persist === true) {
          profiling_object['params']['definitions'][profiling_object_index]['persist_type'] =
            ele.formField.persist_type;
        } else {
          profiling_object['params']['definitions'][profiling_object_index]['persist_type'] = '';
        }
        profiling_object_index++;
        profiling_object_arr.push(profiling_object);
        if (profiling_boolean) {
          steps.push(profiling_object_arr[0]);
          profiling_boolean = false;
        }
        stepCount++;
        previous = true;
      } else if (ele.nodeName === 'Math Transformation') {
        let handle_math_transform_object_index = 0;
        const handle_math_transform_object = new Object();

        handle_math_transform_object['method_name'] = 'MATH_TRANSFORMATION';
        handle_math_transform_object['params'] = new Object();
        handle_math_transform_object['params']['definitions'] = new Array();

        handle_math_transform_object['params']['definitions'][handle_math_transform_object_index] = new Object();
        handle_math_transform_object['params']['definitions'][handle_math_transform_object_index][
          'step_name'
        ] = `math_transformation_${stepCount}`;
        handle_math_transform_object['params']['definitions'][handle_math_transform_object_index]['db_name'] =
          ele.formField.db_name;

        handle_math_transform_object['params']['definitions'][handle_math_transform_object_index]['alias'] =
          ele.formField.alias;
        handle_math_transform_object['params']['definitions'][handle_math_transform_object_index]['sample_view'] =
          ele.formField.sample_view;

        const col_list = [];

        ele.headerName.forEach((el) => {
          if ((el.checked === 'true' || el.checked === true) && el.transform === 'true') {
            if (el.power === '') {
              col_list.push({
                input_col_name: el.header,
                output_col_name: el.output_column,
                transform_type: el.transform_type,
                data_type: el.cast_datatype,
              });
            }
          } else {
            col_list.push({
              input_col_name: el.header,
              output_col_name: el.output_column,
              transform_type: el.transform_type,
              data_type: el.cast_datatype,
              power: el.power ?? '',
            });
          }
        });
        const columns = { col_list };
        handle_math_transform_object['params']['definitions'][handle_math_transform_object_index]['columns'] = columns;

        stepCount++;
        handle_math_transform_object_index++;
        steps.push(handle_math_transform_object);
        previous = true;
      } else if (
        ele.nodeName === 'Write' ||
        ele.nodeName === 'SnowFlake' ||
        ele.nodeName === 'CopyDoc' ||
        ele.nodeName === 'Postgres' ||
        ele.nodeName === 'OpenSearch'
      ) {
        // if (write_object_boolean === false) {
        write_object = new Object();
        write_object['method_name'] = 'Write';
        write_object['params'] = new Object();
        write_object['params']['definitions'] = new Array();
        write_object_boolean = true;
        // }

        write_object['params']['definitions'][handle_write_object_index] = new Object();
        write_object['params']['definitions'][handle_write_object_index]['step_name'] = `Write_${stepCount}`;
        write_object['params']['definitions'][handle_write_object_index]['step_number'] = stepCount;
        write_object['params']['definitions'][handle_write_object_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        if (ele.nodeName !== 'CopyDoc') {
          write_object['params']['definitions'][handle_write_object_index]['sample_view'] = ele.formField.sample_view;
        }
        if (ele.nodeName === 'CopyDoc') {
          const encoder = new TextEncoder('utf-8');
          const pathname = ele.formField.innerPath;
          const filename = pathname.substring(pathname.lastIndexOf('/') + 1);
          const utf8Encoded = encoder.encode(filename);

          const lastIndex = pathname.lastIndexOf('/');
          const pathWithoutFilename = pathname.substring(0, lastIndex);

          write_object['method_name'] = 'Write_SFTP';
          write_object['params']['definitions'][handle_write_object_index]['file_path'] = pathWithoutFilename;
          write_object['params']['definitions'][handle_write_object_index]['utf8Encoded'] = utf8Encoded;
          write_object['params']['definitions'][handle_write_object_index]['client_name_cd'] = ele.formField.clientName;
          write_object['params']['definitions'][handle_write_object_index]['batch_name_cd'] = ele.formField.batchName;
          write_object['params']['definitions'][handle_write_object_index]['job_name_cd'] = ele.formField.tableNameRead;
          write_object['params']['definitions'][handle_write_object_index]['language'] = ele.formField.dataSetName;
          write_object['params']['definitions'][handle_write_object_index]['step_name'] = 'Write_SFTP';
        }
        if (ele.nodeName === 'Write') {
          if (ele.formField.format === 'streaming') {
            write_object['params']['definitions'][handle_write_object_index]['stream_interval'] = parseInt(
              ele.formField.stream_interval,
              10
            );
          }
        }
        if (ele.toggleType === 'S3') {
          write_object['params']['definitions'][handle_write_object_index]['format'] = ele.formField.format;
          write_object['params']['definitions'][handle_write_object_index]['overwrite'] = ele.formField.overwrite;
          write_object['params']['definitions'][handle_write_object_index]['df'] = ele.formField.df;
          write_object['params']['definitions'][handle_write_object_index]['alias'] = ele.formField.alias;
          if (track_id !== 'snowflake-garbageTID') {
            write_object['params']['definitions'][handle_write_object_index][
              'path'
            ] = `${ele.formField.path}${track_id}/`;
          } else {
            write_object['params']['definitions'][handle_write_object_index]['path'] = `${ele.formField.path}`;
          }
          write_object['params']['definitions'][handle_write_object_index]['partition'] = ele.formField.partition;
          write_object['params']['definitions'][handle_write_object_index]['persist'] = ele.formField.persist;
          write_object['params']['definitions'][handle_write_object_index]['distinct_rows'] =
            ele.formField.distinct_rows;

          if (ele.formField.persist === true) {
            write_object['params']['definitions'][handle_write_object_index]['persist_type'] =
              ele.formField.persist_type;
          } else {
            write_object['params']['definitions'][handle_write_object_index]['persist_type'] = '';
          }
          if (ele.formField.format !== 'streaming') {
            write_object['params']['definitions'][handle_write_object_index]['target'] = AWS_CONFIG_TYPE
              ? 's3'
              : 'adls';
          } else {
            write_object['params']['definitions'][handle_write_object_index]['target'] = 'streaming';
          }

          // const newArray = [];

          // if (ele.headerName.length > 0) {
          //   ele.headerName.forEach((el) => {
          //     if (el.alias) {
          //       newArray.push(`${el.header} as ${el.alias}`);
          //     } else {
          //       newArray.push(el.header);
          //     }
          //   });

          //   write_object['params']['definitions'] = newArray.toString();
          // }
        } else if (ele.toggleType === 'Write SFTP') {
          write_object['params']['definitions'][handle_write_object_index]['df'] = ele.formField.df;
          write_object['params']['definitions'][handle_write_object_index]['index'] = ele.formField.index;
          write_object['params']['definitions'][handle_write_object_index]['spark_config'] = ele.formField.spark_config;
          write_object['params']['definitions'][handle_write_object_index]['udf'] = ele.formField.udf;
          write_object['params']['definitions'][handle_write_object_index]['file_path'] = ele.formField.path;
        } else if (ele.toggleType === 'Open Search') {
          write_object['params']['definitions'][handle_write_object_index]['df'] = ele.formField.df;
          write_object['params']['definitions'][handle_write_object_index]['index'] = ele.formField.index;
          write_object['params']['definitions'][handle_write_object_index]['primary_key'] = ele.formField.p_key;
          write_object['params']['definitions'][handle_write_object_index]['target'] = 'opensearch';
          write_object['params']['definitions'][handle_write_object_index]['distinct_rows'] =
            ele.formField.distinct_rows;
        } else if (ele.toggleType === 'Database') {
          write_object['params']['definitions'][handle_write_object_index]['df'] = ele.formField.df;
          write_object['params']['definitions'][handle_write_object_index]['db_type'] = ele.formField.db_type;
          write_object['params']['definitions'][handle_write_object_index]['service'] = ele.formField.database;
          write_object['params']['definitions'][handle_write_object_index]['database'] = ele.formField.schema;
          write_object['params']['definitions'][handle_write_object_index]['tablename'] = ele.formField.tablename;
          write_object['params']['definitions'][handle_write_object_index]['mode'] = ele.formField.mode;
          write_object['params']['definitions'][handle_write_object_index]['target'] = 'database';
          write_object['params']['definitions'][handle_write_object_index]['distinct_rows'] =
            ele.formField.distinct_rows;
          write_object['params']['definitions'][handle_write_object_index]['sample_view'] =
            ele.formField.sample_view === null ? false : ele.formField.sample_view;
        } else if (ele.toggleType === 'SnowFlake') {
          write_object['params']['definitions'][handle_write_object_index]['df'] = ele.formField.df;
          write_object['params']['definitions'][handle_write_object_index]['mode'] = ele.formField.snowflake_mode;
          write_object['params']['definitions'][handle_write_object_index]['dbtable'] =
            ele.formField.snowflake_db_table;
          write_object['params']['definitions'][handle_write_object_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
          write_object['params']['definitions'][handle_write_object_index]['database'] = ele.formField.database;
          write_object['params']['definitions'][handle_write_object_index]['schema'] = ele.formField.schema;
          write_object['params']['definitions'][handle_write_object_index]['target'] = 'snowflake';
          write_object['params']['definitions'][handle_write_object_index]['sample_view'] =
            ele.formField.sample_view === null ? false : ele.formField.sample_view;
          write_object['params']['definitions'][handle_write_object_index]['distinct_rows'] =
            ele.formField.distinct_rows;
          write_object['params']['definitions'][handle_write_object_index]['persist'] = ele.formField.persist;
          if (ele.formField.persist === true) {
            write_object['params']['definitions'][handle_write_object_index]['persist_type'] =
              ele.formField.persist_type;
          } else {
            write_object['params']['definitions'][handle_write_object_index]['persist_type'] = '';
          }
        }

        // handle_write_object_index++;
        // write_object_arr.push(write_object);
        // if (write_boolean) {
        //   steps.push(write_object_arr[0]);
        //   write_boolean = false;
        // }

        stepCount++;
        steps.push(write_object);
        previous = true;
      } else if (ele.nodeName === 'Email') {
        let email_object_index = 0;
        const email_object = new Object();

        email_object['method_name'] = 'SENDEMAIL';
        email_object['params'] = new Object();
        email_object['params']['definitions'] = new Array();

        email_object['params']['definitions'][email_object_index] = new Object();
        email_object['params']['definitions'][email_object_index]['step_name'] = `sendemail_${stepCount}`;
        email_object['params']['definitions'][email_object_index]['step_number'] = stepCount;
        email_object['params']['definitions'][email_object_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        email_object['params']['definitions'][email_object_index]['df'] = ele.formField.df;
        email_object['params']['definitions'][email_object_index]['column'] = ele.formField.column;
        email_object['params']['definitions'][email_object_index]['filter_condition'] = ele.formField.filter_condition;
        email_object['params']['definitions'][email_object_index]['operator'] = ele.formField.operator;
        email_object['params']['definitions'][email_object_index]['recipients_list'] =
          ele.formField.recipients_list.split(',');
        email_object['params']['definitions'][email_object_index]['subject'] = ele.formField.subject;
        email_object['params']['definitions'][email_object_index]['column'] = ele.formField.column;

        email_object['params']['definitions'][email_object_index]['alias'] = ele.formField.alias;
        email_object['params']['definitions'][email_object_index]['sample_view'] = ele.formField.sample_view;

        stepCount++;
        email_object_index++;
        steps.push(email_object);
      } else if (ele.nodeName === 'WriteCsvAWS') {
        let WriteCsvAWS_defination_index = 0;

        const WriteCsvAWS_object = new Object();

        WriteCsvAWS_object['method_name'] = 'Write';

        WriteCsvAWS_object['params'] = new Object();

        WriteCsvAWS_object['params']['definitions'] = new Array();
        WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index] = new Object();
        WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index] = new Object();
        WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index][
          'step_name'
        ] = `WriteCsvAWS_${stepCount}`;
        WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index]['step_number'] = stepCount;
        WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index]['sample_view'] =
          ele.formField.sample_view;
        WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index]['distinct_rows'] =
          ele.formField.distinct_rows;
        WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index]['df'] = ele.formField.df;
        WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index]['alias'] = ele.formField.alias;
        WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index]['path'] = ele.formField.path;
        WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index]['mode'] = ele.formField.mode;
        WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index]['overwrite'] = true;
        WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index]['partition'] =
          ele.formField.partition;
        WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index]['format'] = ele.formField.format;
        WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index]['persist'] = ele.formField.persist;
        if (ele.formField.persist === true) {
          WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index]['persist_type'] =
            ele.formField.persist_type;
        } else {
          WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index]['persist_type'] = '';
        }
        WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index]['connection_type'] =
          ele.formField.connection_type;
        WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index]['secret_name'] = updatedSecretName(
          's3',
          ele.formField.secret_name
        );
        WriteCsvAWS_object['params']['definitions'][WriteCsvAWS_defination_index]['target'] = 's3';

        stepCount++;
        WriteCsvAWS_defination_index++;
        steps.push(WriteCsvAWS_object);
        previous = true;
      } else if (ele.nodeName === 'WriteAzure') {
        let WriteAzure_defination_index = 0;

        const WriteAzure_object = new Object();

        WriteAzure_object['method_name'] = 'Write';

        WriteAzure_object['params'] = new Object();

        WriteAzure_object['params']['definitions'] = new Array();
        WriteAzure_object['params']['definitions'][WriteAzure_defination_index] = new Object();
        WriteAzure_object['params']['definitions'][WriteAzure_defination_index] = new Object();
        WriteAzure_object['params']['definitions'][WriteAzure_defination_index][
          'step_name'
        ] = `WriteAzure_${stepCount}`;
        WriteAzure_object['params']['definitions'][WriteAzure_defination_index]['step_number'] = stepCount;
        WriteAzure_object['params']['definitions'][WriteAzure_defination_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        WriteAzure_object['params']['definitions'][WriteAzure_defination_index]['sample_view'] =
          ele.formField.sample_view;
        WriteAzure_object['params']['definitions'][WriteAzure_defination_index]['distinct_rows'] =
          ele.formField.distinct_rows;
        WriteAzure_object['params']['definitions'][WriteAzure_defination_index]['path'] = ele.formField.path;
        WriteAzure_object['params']['definitions'][WriteAzure_defination_index]['df'] = ele.formField.df;
        WriteAzure_object['params']['definitions'][WriteAzure_defination_index]['alias'] = ele.formField.alias;
        WriteAzure_object['params']['definitions'][WriteAzure_defination_index]['partition'] = ele.formField.partition;
        WriteAzure_object['params']['definitions'][WriteAzure_defination_index]['mode'] = ele.formField.mode;
        WriteAzure_object['params']['definitions'][WriteAzure_defination_index]['secret_name'] = updatedSecretName(
          'adls',
          ele.formField.secret_name
        );
        WriteAzure_object['params']['definitions'][WriteAzure_defination_index]['connection_type'] =
          ele.formField.connection_type;
        WriteAzure_object['params']['definitions'][WriteAzure_defination_index]['target'] = 'azure';
        WriteAzure_object['params']['definitions'][WriteAzure_defination_index]['format'] = ele.formField.format;
        WriteAzure_object['params']['definitions'][WriteAzure_defination_index]['persist'] = ele.formField.persist;
        if (ele.formField.persist === true) {
          WriteAzure_object['params']['definitions'][WriteAzure_defination_index]['persist_type'] =
            ele.formField.persist_type;
        } else {
          WriteAzure_object['params']['definitions'][WriteAzure_defination_index]['persist_type'] = '';
        }

        stepCount++;
        WriteAzure_defination_index++;
        steps.push(WriteAzure_object);
        previous = true;
      } else if (ele.nodeName === 'WritePostgres') {
        let WritePostgres_defination_index = 0;

        const WritePostgres_object = new Object();

        WritePostgres_object['method_name'] = 'Write';

        WritePostgres_object['params'] = new Object();

        WritePostgres_object['params']['definitions'] = new Array();
        WritePostgres_object['params']['definitions'][WritePostgres_defination_index] = new Object();
        WritePostgres_object['params']['definitions'][WritePostgres_defination_index] = new Object();
        WritePostgres_object['params']['definitions'][WritePostgres_defination_index][
          'step_name'
        ] = `WritePostgres_${stepCount}`;
        WritePostgres_object['params']['definitions'][WritePostgres_defination_index]['step_number'] = stepCount;
        WritePostgres_object['params']['definitions'][WritePostgres_defination_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        WritePostgres_object['params']['definitions'][WritePostgres_defination_index]['sample_view'] =
          ele.formField.sample_view;
        WritePostgres_object['params']['definitions'][WritePostgres_defination_index]['distinct_rows'] =
          ele.formField.distinct_rows;
        WritePostgres_object['params']['definitions'][WritePostgres_defination_index]['df'] = ele.formField.df;
        WritePostgres_object['params']['definitions'][WritePostgres_defination_index]['alias'] = ele.formField.alias;
        WritePostgres_object['params']['definitions'][WritePostgres_defination_index]['partition'] =
          ele.formField.partition;
        WritePostgres_object['params']['definitions'][WritePostgres_defination_index][''] = ele.formField.schema;
        WritePostgres_object['params']['definitions'][WritePostgres_defination_index]['db_type'] =
          ele.formField.db_type;
        WritePostgres_object['params']['definitions'][WritePostgres_defination_index]['mode'] = ele.formField.mode;
        WritePostgres_object['params']['definitions'][WritePostgres_defination_index]['database'] =
          ele.formField.schema;
        WritePostgres_object['params']['definitions'][WritePostgres_defination_index]['connection_type'] =
          ele.formField.connection_type;
        WritePostgres_object['params']['definitions'][WritePostgres_defination_index]['tablename'] =
          ele.formField.tablename;
        WritePostgres_object['params']['definitions'][WritePostgres_defination_index]['format'] = ele.formField.format;

        WritePostgres_object['params']['definitions'][WritePostgres_defination_index]['secret_name'] =
          updatedSecretName('postgresql', ele.formField.secret_name);
        WritePostgres_object['params']['definitions'][WritePostgres_defination_index]['target'] = 'database';
        stepCount++;
        WritePostgres_defination_index++;
        steps.push(WritePostgres_object);
        previous = true;
      } else if (ele.nodeName === 'WriteSnowflake') {
        let WriteSnowflake_defination_index = 0;

        const WriteSnowflake_object = new Object();

        WriteSnowflake_object['method_name'] = 'Write';

        WriteSnowflake_object['params'] = new Object();

        WriteSnowflake_object['params']['definitions'] = new Array();
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index] = new Object();
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index] = new Object();
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index][
          'step_name'
        ] = `WriteSnowflake_${stepCount}`;
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index]['step_number'] = stepCount;
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index]['sample_view'] =
          ele.formField.sample_view;
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index]['distinct_rows'] =
          ele.formField.distinct_rows;
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index]['df'] = ele.formField.df;
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index]['alias'] = ele.formField.alias;
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index]['db_type'] =
          ele.formField.db_type;
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index]['partition'] =
          ele.formField.partition;
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index]['format'] =
          ele.formField.format;
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index]['persist'] =
          ele.formField.persist;
        if (ele.formField.persist === true) {
          WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index]['persist_type'] =
            ele.formField.persist_type;
        } else {
          WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index]['persist_type'] = '';
        }
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index]['mode'] = ele.formField.mode;
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index]['database'] =
          ele.formField.database;
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index]['schema'] =
          ele.formField.schema;
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index]['connection_type'] =
          ele.formField.connection_type;
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index]['tablename'] =
          ele.formField.tablename;
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index]['secret_name'] =
          updatedSecretName('snowflake', ele.formField.secret_name);
        WriteSnowflake_object['params']['definitions'][WriteSnowflake_defination_index]['target'] = 'snowflake';
        stepCount++;
        WriteSnowflake_defination_index++;
        steps.push(WriteSnowflake_object);
        previous = true;
      } else if (ele.nodeName === 'WriteSqlServer') {
        let WriteSqlServer_defination_index = 0;

        const WriteSqlServer_object = new Object();

        WriteSqlServer_object['method_name'] = 'Write';

        WriteSqlServer_object['params'] = new Object();

        WriteSqlServer_object['params']['definitions'] = new Array();
        WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index] = new Object();
        WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index] = new Object();
        WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index][
          'step_name'
        ] = `WriteSqlServer_${stepCount}`;
        WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index]['step_number'] = stepCount;
        WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index]['sample_view'] =
          ele.formField.sample_view;
        WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index]['distinct_rows'] =
          ele.formField.distinct_rows;
        WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index]['df'] = ele.formField.df;
        WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index]['format'] =
          ele.formField.format;
        WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index]['partition'] =
          ele.formField.partition;
        WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index]['persist'] =
          ele.formField.persist;
        if (ele.formField.persist === true) {
          WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index]['persist_type'] =
            ele.formField.persist_type;
        } else {
          WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index]['persist_type'] = '';
        }
        // WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index]['alias'] = ele.formField.alias;
        WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index]['db_type'] =
          ele.formField.db_type;
        WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index]['mode'] = ele.formField.mode;
        WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index]['database'] =
          ele.formField.schema;
        WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index]['connection_type'] =
          ele.formField.connection_type;
        WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index]['tablename'] =
          ele.formField.tablename;
        WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index]['secret_name'] =
          updatedSecretName('sqlserver', ele.formField.secret_name);
        WriteSqlServer_object['params']['definitions'][WriteSqlServer_defination_index]['target'] = 'database';
        stepCount++;
        WriteSqlServer_defination_index++;
        steps.push(WriteSqlServer_object);
        previous = true;
      } else if (ele.nodeName === 'WriteOracleDB') {
        let WriteOracleDB_defination_index = 0;

        const WriteOracleDB_object = new Object();

        WriteOracleDB_object['method_name'] = 'Write';

        WriteOracleDB_object['params'] = new Object();

        WriteOracleDB_object['params']['definitions'] = new Array();
        WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index] = new Object();
        WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index] = new Object();
        WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index][
          'step_name'
        ] = `WriteOracleDB_${stepCount}`;
        WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index]['step_number'] = stepCount;
        WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index]['sample_view'] =
          ele.formField.sample_view;
        WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index]['distinct_rows'] =
          ele.formField.distinct_rows;
        WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index]['partition'] =
          ele.formField.partition;
        WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index]['format'] = ele.formField.format;
        WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index]['persist'] =
          ele.formField.persist;
        if (ele.formField.persist === true) {
          WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index]['persist_type'] =
            ele.formField.persist_type;
        } else {
          WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index]['persist_type'] = '';
        }
        WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index]['df'] = ele.formField.df;
        // WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index]['alias'] = ele.formField.alias;
        WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index]['db_type'] =
          ele.formField.db_type;
        WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index]['mode'] = ele.formField.mode;
        WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index]['database'] =
          ele.formField.database;
        WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index]['connection_type'] =
          ele.formField.connection_type;
        WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index]['tablename'] =
          ele.formField.tablename;
        WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index]['secret_name'] =
          updatedSecretName('oracle', ele.formField.secret_name);
        WriteOracleDB_object['params']['definitions'][WriteOracleDB_defination_index]['target'] = 'database';
        stepCount++;
        WriteOracleDB_defination_index++;
        steps.push(WriteOracleDB_object);
        previous = true;
      } else if (ele.nodeName === 'DataProfiling') {
        const validation_object = new Object();
        let validation_object_index = 0;

        validation_object['method_name'] = 'DataValidation';
        validation_object['params'] = new Object();
        validation_object['params']['definitions'] = new Array();
        validation_object['params']['definitions'][validation_object_index] = new Object();
        validation_object['params']['definitions'][validation_object_index]['step_name'] = `Validate_${stepCount}`;
        validation_object['params']['definitions'][validation_object_index]['step_number'] = stepCount;
        validation_object['params']['definitions'][validation_object_index]['df'] = ele.formField.df;
        validation_object['params']['definitions'][validation_object_index]['alias'] = ele.formField.alias;
        validation_object['params']['definitions'][validation_object_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        validation_object['params']['definitions'][validation_object_index]['sample_view'] = ele.formField.sample_view;
        validation_object['params']['definitions'][validation_object_index]['persist'] = ele.formField.persist;
        validation_object['params']['definitions'][validation_object_index]['persist_type'] =
          ele.formField.persist_type;
        validation_object['params']['definitions'][validation_object_index]['action'] = ele.formField.action;
        validation_object['params']['definitions'][validation_object_index]['path_validation'] = ele.formField.path;
        validation_object['params']['definitions'][validation_object_index]['path_profiling'] =
          ele.formField.profilingPath;

        const expectations_details = [];
        const newCol = [...ele.columnName];

        newCol.map((item) => {
          if (item.validation_name !== '') {
            const data = {
              expectation_name: item.validation_name,
              column: item.column,
            };

            delete item['validation_name'];
            delete item['column'];

            let param;

            if (data.expectation_name === 'expect_column_values_to_be_between') {
              param = {
                expectation_name: data.expectation_name,
                args: {
                  column: data.column,
                  max_value: parseInt(item.max_value, 10),
                  min_value: parseInt(item.min_value, 10),
                },
              };
            } else if (data.expectation_name === 'expect_column_values_to_be_in_set') {
              param = {
                expectation_name: data.expectation_name,
                args: {
                  column: data.column,
                  value_set: item.value_set.split(','),
                },
              };
            } else {
              param = {
                expectation_name: data.expectation_name,
                args: { column: data.column, ...item },
              };
            }

            expectations_details.push(param);
          }
        });

        validation_object['params']['definitions'][validation_object_index]['expectations_details'] =
          expectations_details;

        steps.push(validation_object);
        stepCount++;
        validation_object_index++;
        previous = true;
      } else if (ele.nodeName === 'Rules Selector') {
        const rules_selector_index = 0;
        const rules_selector_object = new Object();
        rules_selector_object['method_name'] = 'RuleSelectorNew';
        rules_selector_object['params'] = new Object();
        rules_selector_object['params']['definitions'] = new Array();

        rules_selector_object['params']['definitions'][rules_selector_index] = new Object();
        rules_selector_object['params']['definitions'][rules_selector_index]['step_name'] = `RuleSelector_${stepCount}`;
        rules_selector_object['params']['definitions'][rules_selector_index]['step_number'] = stepCount;
        rules_selector_object['params']['definitions'][rules_selector_index]['df'] = ele.formField.df;

        rules_selector_object['params']['definitions'][rules_selector_index]['alias'] = ele.formField.alias;
        rules_selector_object['params']['definitions'][rules_selector_index]['format'] = ele.formField.format;
        rules_selector_object['params']['definitions'][rules_selector_index]['path'] = ele.formField.innerPath;

        rules_selector_object['params']['definitions'][rules_selector_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;

        rules_selector_object['params']['definitions'][rules_selector_index]['distinct_rows'] =
          ele.formField.distinct_rows;
        rules_selector_object['params']['definitions'][rules_selector_index]['sample_view'] = ele.formField.sample_view;

        rules_selector_object['params']['definitions'][rules_selector_index]['action'] = ele.formField.action
          ? ele.formField.action
          : '';

        const rule_list = [];

        if (ele.formField.rule_list.length > 0) {
          ele.formField.rule_list.forEach((el) => {
            if (el.checked && el.metric && el.format && el.field_name && el.unit) {
              rule_list.push({ format: el.format, field_name: el.field_name, unit: el.unit, metric: el.metric });
            }
          });
        }
        ele.formField.configDataNew.forEach((el) => {
          if (el.statement && el.field_name && el.dataType && el.metric) {
            rule_list.push({
              format: el.statement,
              field_name: el.field_name,
              unit: el.dataType,
              metric: el.metric,
            });
          }
        });
        if (ele.formField.configData.length > 0) {
          ele.formField.configData.forEach((el) => {
            if (el.statement && el.field_name && el.dataType && el.metric) {
              rule_list.push({
                format: el.statement,
                field_name: el.field_name,
                unit: el.dataType,
                metric: el.metric,
              });
            }
          });
        }
        rules_selector_object['params']['definitions'][rules_selector_index]['rule_list'] = rule_list;

        rules_selector_object['params']['definitions'][rules_selector_index]['action'] = ele.formField.action
          ? ele.formField.action
          : '';

        stepCount++;
        steps.push(rules_selector_object);
        previous = true;
      } else if (ele.nodeName === 'AutomaticRuleGenerator') {
        const autoRuleGene_object_index = 0;
        const autoRuleGene_object = new Object();
        autoRuleGene_object['method_name'] = ele.nodeName;
        autoRuleGene_object['params'] = new Object();
        autoRuleGene_object['params']['definitions'] = new Array();

        autoRuleGene_object['params']['definitions'][autoRuleGene_object_index] = new Object();
        autoRuleGene_object['params']['definitions'][autoRuleGene_object_index][
          'step_name'
        ] = `${ele.step_name}_${stepCount}`;
        autoRuleGene_object['params']['definitions'][autoRuleGene_object_index]['step_number'] = stepCount;
        autoRuleGene_object['params']['definitions'][autoRuleGene_object_index]['df'] = ele.formField.df;

        autoRuleGene_object['params']['definitions'][autoRuleGene_object_index]['format'] = ele.formField.format;
        autoRuleGene_object['params']['definitions'][autoRuleGene_object_index]['path'] = ele.formField.path;

        autoRuleGene_object['params']['definitions'][autoRuleGene_object_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;

        autoRuleGene_object['params']['definitions'][autoRuleGene_object_index]['distinct_rows'] =
          ele.formField.distinct_rows;
        autoRuleGene_object['params']['definitions'][autoRuleGene_object_index]['sample_view'] =
          ele.formField.sample_view;

        autoRuleGene_object['params']['definitions'][autoRuleGene_object_index]['action'] = ele.formField.action
          ? ele.formField.action
          : '';

        const header_list = [];
        if (ele.headerName.length > 0) {
          ele.headerName.forEach((el) => {
            const updatedHeader = el.header.includes('.') ? `\`${el.header}\`` : `${el.header}`;
            header_list.push(updatedHeader);
          });
        }
        autoRuleGene_object['params']['definitions'][autoRuleGene_object_index]['col_list'] = header_list;

        autoRuleGene_object['params']['definitions'][autoRuleGene_object_index]['action'] = ele.formField.action
          ? ele.formField.action
          : '';

        stepCount++;
        steps.push(autoRuleGene_object);
        previous = true;
      } else if (
        ele.nodeName === 'Execute SQL' ||
        ele.nodeName === 'Rule Generator' ||
        ele.nodeName === 'Sort' ||
        ele.nodeName === 'Filter' ||
        ele.nodeName === 'Aggregation' ||
        ele.nodeName === 'Coalesce' ||
        ele.nodeName === 'Union' ||
        ele.nodeName === 'FlatUnion' ||
        ele.nodeName === 'KPI'
      ) {
        if (previous) {
          executeSQL_object_boolean = false;
          executeSQL_boolean = true;
          execute_sql_object_arr = [];
          executeSQL_object_index = 0;
        }
        // if (executeSQL_object_boolean === false) {
        executeSQL_object = new Object();
        executeSQL_object['method_name'] = ele.nodeName === 'FlatUnion' ? 'FlatUnion' : 'ExecuteSQL';
        executeSQL_object['params'] = new Object();
        executeSQL_object['params']['definitions'] = new Array();
        executeSQL_object_boolean = true;
        // }
        executeSQL_object['params']['definitions'][executeSQL_object_index] = new Object();
        executeSQL_object['params']['definitions'][executeSQL_object_index][
          'step_name'
        ] = `${ele.step_name}_${stepCount}`;
        executeSQL_object['params']['definitions'][executeSQL_object_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        if (ele.toggleType === 'KPI') {
          executeSQL_object['params']['definitions'][executeSQL_object_index]['sql_type'] = ele.toggleType;
          executeSQL_object['params']['definitions'][executeSQL_object_index]['KPI'] = ele.formField.kpi;
          executeSQL_object['params']['definitions'][executeSQL_object_index]['kpi_id'] = ele.formField.kpi_id;
          executeSQL_object['params']['definitions'][executeSQL_object_index]['step_number'] = stepCount;
          executeSQL_object['params']['definitions'][executeSQL_object_index]['df'] = ele.formField.alias;
          executeSQL_object['params']['definitions'][executeSQL_object_index]['db_name'] = ele.formField.db_name;
          executeSQL_object['params']['definitions'][executeSQL_object_index]['statement'] = ele.formField.statement;
          executeSQL_object['params']['definitions'][executeSQL_object_index]['persist'] = ele.formField.persist;
          executeSQL_object['params']['definitions'][executeSQL_object_index]['sample_view'] =
            ele.formField.sample_view;
          executeSQL_object['params']['definitions'][executeSQL_object_index]['distinct_rows'] =
            ele.formField.distinct_rows;
          if (ele.formField.persist === true) {
            executeSQL_object['params']['definitions'][executeSQL_object_index]['persist_type'] =
              ele.formField.persist_type;
          } else {
            executeSQL_object['params']['definitions'][executeSQL_object_index]['persist_type'] = '';
          }
          executeSQL_object['params']['definitions'][executeSQL_object_index]['action'] = ele.formField.action
            ? ele.formField.action
            : '';
          const newArray = [];
          if (ele.headerName.length > 0) {
            ele.headerName.forEach((el) => {
              if (el.alias) {
                newArray.push(`${el.header} as ${el.alias}`);
              } else {
                newArray.push(el.header);
              }
            });
          }
          executeSQL_object['params']['definitions'][executeSQL_object_index]['select_cols'] = newArray.toString();
        } else {
          executeSQL_object['params']['definitions'][executeSQL_object_index]['sql_type'] = 'Execute SQL';
          executeSQL_object['params']['definitions'][executeSQL_object_index]['step_number'] = stepCount;
          executeSQL_object['params']['definitions'][executeSQL_object_index]['df'] = ele.formField.alias;
          executeSQL_object['params']['definitions'][executeSQL_object_index]['db_name'] = ele.formField.db_name;
          executeSQL_object['params']['definitions'][executeSQL_object_index]['statement'] = ele.formField.statement;
          executeSQL_object['params']['definitions'][executeSQL_object_index]['sample_view'] =
            ele.formField.sample_view;
          executeSQL_object['params']['definitions'][executeSQL_object_index]['persist'] = ele.formField.persist;
          executeSQL_object['params']['definitions'][executeSQL_object_index]['distinct_rows'] =
            ele.formField.distinct_rows;
          if (ele.formField.persist === true) {
            executeSQL_object['params']['definitions'][executeSQL_object_index]['persist_type'] =
              ele.formField.persist_type;
          } else {
            executeSQL_object['params']['definitions'][executeSQL_object_index]['persist_type'] = '';
          }
          executeSQL_object['params']['definitions'][executeSQL_object_index]['action'] = ele.formField.action
            ? ele.formField.action
            : '';
        }

        if (ele.nodeName === 'FlatUnion') {
          executeSQL_object['params']['definitions'][executeSQL_object_index]['df_list'] = ele.formField.df_list;
        }

        // executeSQL_object_index++;
        // execute_sql_object_arr.push(executeSQL_object);
        // // const new_execute_sql_object_arr = [...execute_sql_object_arr]
        // if (executeSQL_boolean) {
        //   steps.push(execute_sql_object_arr[0]);
        //   executeSQL_boolean = false;
        // }

        stepCount++;
        steps.push(executeSQL_object);
        previous = false;
      } else if (ele.nodeName === DATA_QUALITY_AGENT.nodeModalTitle) {
        isAgentAvailable = true;
        const agentObj = {
          method_name: DATA_QUALITY_AGENT.jsonMethodName,
          params: {
            definitions: [
              {
                step_name: DATA_QUALITY_AGENT.jsonMethodName,
                step_number: stepCount,
                node_id: `${ele.nodeId}__${workflow_id}`,
                df: ele.formField.df,
              },
            ],
          },
        };
        stepCount++;
        steps.push(agentObj);
        previous = true;
      } else if (ele.nodeName === DEDUPLICATION_AGENT.nodeModalTitle) {
        isAgentAvailable = true;
        const agentObj = {
          method_name: DEDUPLICATION_AGENT.jsonMethodName,
          params: {
            definitions: [
              {
                step_name: DEDUPLICATION_AGENT.jsonMethodName,
                step_number: stepCount,
                node_id: `${ele.nodeId}__${workflow_id}`,
                input_paths: ele.formField.col_list,
                ...DEDUPLICATION_AGENT.configJson,
              },
            ],
          },
        };
        stepCount++;
        steps.push(agentObj);
        previous = true;
      } else if (ele.nodeName === 'Data Cleansing') {
        const Data_Cleansing_object = new Object();
        Data_Cleansing_object['method_name'] = 'RuleEngine';
        Data_Cleansing_object['params'] = new Object();
        Data_Cleansing_object['params']['flow_name'] = 'Data Cleansing';
        Data_Cleansing_object['params']['step_name'] = ele.step_name;
        Data_Cleansing_object['params']['step_number'] = stepCount;
        Data_Cleansing_object['params']['node_id'] = `${ele.nodeId}__${workflow_id}`;
        Data_Cleansing_object['params']['log_group'] = 'cdep_rule_engine_logs';
        Data_Cleansing_object['params']['execution_id'] = `${ele.client_name}_${ele.batch_name}_${
          ele.table_name
        }_${new Date().getTime()}`;
        Data_Cleansing_object['params']['engagement_name'] = ele.batch_name;
        Data_Cleansing_object['params']['client_name'] = ele.client_name;
        Data_Cleansing_object['params']['workflow_name'] = ele.table_name;
        Data_Cleansing_object['params']['bucket_name'] = BUCKET_NAME;
        Data_Cleansing_object['params']['jar_folder_path'] = `s3://${BUCKET_NAME}/rule_engine/jars/*`;
        Data_Cleansing_object['params']['job_status_table'] = 'dep_rule_engine_job_status';
        Data_Cleansing_object['params']['db_audit_table'] = 'dep_rule_engine_audit_table';
        Data_Cleansing_object['params']['region_name'] = 'us-east-1';
        Data_Cleansing_object['params']['extensions'] = '[.txt,.csv,.json]';
        Data_Cleansing_object['params']['profile_env'] = 'dev';
        Data_Cleansing_object['params']['profile_env_bucket'] = BUCKET_NAME;
        Data_Cleansing_object['params']['db_status_table'] = 'dep_rule_engine_workflow_status';
        Data_Cleansing_object['params']['df'] = ele.table_name;
        Data_Cleansing_object['params']['db_name'] = 'default';
        Data_Cleansing_object['params']['alias'] = ele.formField.alias;
        Data_Cleansing_object['params']['distinct_rows'] = ele.formField.distinct_rows;
        Data_Cleansing_object['params']['sample_view'] = ele.formField.sample_view;
        Data_Cleansing_object['params']['ruleFile'] = new Object();

        const allFields = [];
        ele.initial_rules.forEach((el) => {
          const field_rules = [];
          el.rulename.forEach((e_rule) => {
            ele.customRules.forEach((e_cust) => {
              if (e_rule === e_cust.rulename) {
                const argkey = e_cust.argkey.split(',');
                const argvalue = e_cust.argvalue.split(',');
                const obj1 = {};
                argkey.map((element, argkey_idx) => {
                  obj1[element] = argvalue[argkey_idx];
                });
                const obj = new Object();
                obj['rulename'] = e_rule;
                obj['args'] = [obj1];
                field_rules.push(obj);
              }
            });
          });

          const data = {
            fieldname: el.header,
            size: 10,
            scale: 50,
            type: el.type,
            rulename: [],
            fieldrules: field_rules,
          };
          allFields.push(data);
        });
        Data_Cleansing_object['params']['ruleFile']['fields'] = allFields;

        Data_Cleansing_object['params']['ruleFile']['swap'] = ele.swap_Cols;
        Data_Cleansing_object['params']['ruleFile']['delete'] = ele.delete_cols;

        stepCount++;
        steps.push(Data_Cleansing_object);
        previous = true;
      } else if (ele.nodeName === 'Data Cleaning & Validation') {
        const rule_engine_object = new Object();
        rule_engine_object['method_name'] = 'DataCleaning&Validation';
        rule_engine_object['params'] = new Object();
        rule_engine_object['params']['step_name'] = ele.step_name;
        rule_engine_object['params']['step_number'] = stepCount;
        rule_engine_object['params']['node_id'] = `${ele.nodeId}__${workflow_id}`;
        rule_engine_object['params']['alias'] = ele.formField.alias;
        rule_engine_object['params']['sample_view'] = ele.formField.sample_view;
        rule_engine_object['params']['db_name'] = 'default';
        rule_engine_object['params']['df'] = ele.formField.df;

        rule_engine_object['params']['ruleFile'] = new Object();

        const validate_email = [];
        const validate_phone = [];

        ele.cleansingRules.forEach((el) => {
          if (
            (el.checked === 'true' || el.checked === true || el.selected === true) &&
            el.validation === 'validate_email'
          ) {
            validate_email.push(el.header);
          } else if (
            (el.checked === 'true' || el.checked === true || el.selected === true) &&
            el.validation === 'validate_phone'
          ) {
            validate_phone.push(el.header);
          }
        });

        rule_engine_object['params']['validate_email'] = validate_email;
        rule_engine_object['params']['validate_phone'] = validate_phone;

        const allFields = [];
        ele.cleansingRules.forEach((el) => {
          const field_rules = [];
          el.rulename.forEach((e_rule) => {
            ele.customRules.forEach((e_cust) => {
              if (e_rule === e_cust.rulename) {
                const argkey = e_cust.argkey.split(',');
                const argvalue = e_cust.argvalue.split(',');
                const obj1 = {};
                argkey.map((element, argkey_idx) => {
                  obj1[element] = argvalue[argkey_idx];
                });
                const obj = new Object();
                obj['rulename'] = e_rule;
                // obj['args'] = [obj1];
                field_rules.push(obj);
              }
            });
          });

          const data = {
            fieldname: el.header,
            type: el.type,
            // rulename: [],
            fieldrules: field_rules,
          };
          allFields.push(data);
        });
        rule_engine_object['params']['ruleFile']['fields'] = allFields;

        stepCount++;
        steps.push(rule_engine_object);
        previous = true;
      } else if (ele.nodeName === 'Fuzzy Match') {
        let fuzzy_match_object_index = 0;
        const fuzzy_match_object = new Object();

        fuzzy_match_object['method_name'] = 'FUZZY_MATCH';
        fuzzy_match_object['params'] = new Object();
        fuzzy_match_object['params']['definitions'] = new Array();

        fuzzy_match_object['params']['definitions'][fuzzy_match_object_index] = new Object();
        fuzzy_match_object['params']['definitions'][fuzzy_match_object_index]['step_name'] = `fuzzy_match_${stepCount}`;
        fuzzy_match_object['params']['definitions'][fuzzy_match_object_index]['step_number'] = stepCount;
        fuzzy_match_object['params']['definitions'][fuzzy_match_object_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        fuzzy_match_object['params']['definitions'][fuzzy_match_object_index]['df'] = ele.formField.df;
        fuzzy_match_object['params']['definitions'][fuzzy_match_object_index]['alias'] = ele.formField.alias;
        fuzzy_match_object['params']['definitions'][fuzzy_match_object_index]['sample_view'] =
          ele.formField.sample_view;

        fuzzy_match_object['params']['definitions'][fuzzy_match_object_index]['algorithm'] = ele.formField.algorithm;

        const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes'));

        const priorities = getAllNodes
          ?.filter(
            (item) =>
              item.nodeName === 'ReadCSV' ||
              item.nodeName === 'ReadCSVData' ||
              item.nodeName === 'ReadCSVAws' ||
              item.nodeName === 'ReadCSVAzure' ||
              item.nodeName === 'PdfDataExtractor' ||
              item.nodeName === 'Rules Selector' ||
              item.nodeName === 'AutomaticRuleGenerator' ||
              // item.nodeName === 'DataQualityIssues' ||
              // item.nodeName === 'DataQualityIssues2' ||
              item.nodeName === 'DataProfiling' ||
              item.nodeName === 'VisualInsights' ||
              // item.nodeName === 'CopyADLS' ||
              item.nodeName === 'ReadPublishedData' ||
              item.nodeName === 'Read' ||
              item.nodeName === 'ReadStreaming' ||
              item.nodeName === 'ReadDelimited' ||
              item.nodeName === 'ReadOracle' ||
              item.nodeName === 'ReadOracleDB' ||
              item.nodeName === 'ReadPostgres' ||
              item.nodeName === 'ReadPostgres2' ||
              item.nodeName === FETCH_SCHEMA.nodeModalTitle ||
              item.nodeName === 'ReadDB2' ||
              item.nodeName === 'ReadAuroraDB' ||
              item.nodeName === 'ReadCosmos' ||
              item.nodeName === 'ReadSQLServer' ||
              item.nodeName === 'ReadMySql' ||
              item.nodeName === 'ReadSnowflake' ||
              item.nodeName === 'ReadSnowflake2' ||
              item.nodeName === 'Read Real-Time' ||
              item.nodeName === 'FileUploader'
          )
          .map((ele) => ({ source: ele.formField.alias, priority: parseInt(ele.formField.priority, 10) }));

        const col_list = [];
        const fuzzy_match = [];
        const exact_match = [];

        ele.headerName.forEach((el) => {
          if ((el.checked === 'true' || el.checked === true) && el.merge_rule) {
            col_list.push({
              input_col_name: el.header,
              merge_rule: el.merge_rule,
            });
          }
        });

        ele.headerName.forEach((el) => {
          if ((el.checked === 'true' || el.checked === true) && el.match_type === 'fuzzy') {
            fuzzy_match.push(el.header);
          }
        });

        ele.headerName.forEach((el) => {
          if ((el.checked === 'true' || el.checked === true) && el.match_type === 'exact') {
            exact_match.push(el.header);
          }
        });

        const columns = { col_list };
        fuzzy_match_object['params']['definitions'][fuzzy_match_object_index]['columns'] = columns;
        fuzzy_match_object['params']['definitions'][fuzzy_match_object_index]['fuzzy_match'] = fuzzy_match;
        fuzzy_match_object['params']['definitions'][fuzzy_match_object_index]['exact_match'] = exact_match;
        fuzzy_match_object['params']['definitions'][fuzzy_match_object_index]['source_priority'] = priorities;

        stepCount++;
        fuzzy_match_object_index++;
        steps.push(fuzzy_match_object);
        previous = true;
      }
      // else if (ele.nodeName === 'Match & Merge') {
      //   let match_merge_object_index = 0;
      //   const match_merge_object = new Object();

      //   match_merge_object['method_name'] = 'MatchAndMerge';
      //   match_merge_object['params'] = new Object();
      //   match_merge_object['params']['definitions'] = new Array();

      //   match_merge_object['params']['definitions'][match_merge_object_index] = new Object();
      //   match_merge_object['params']['definitions'][match_merge_object_index][
      //     'step_name'
      //   ] = `MatchAndMerge${stepCount}`;
      //   match_merge_object['params']['definitions'][match_merge_object_index]['step_number'] = stepCount;
      //   match_merge_object['params']['definitions'][match_merge_object_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
      //   // match_merge_object['params']['definitions'][match_merge_object_index]['df'] = ele.formField.df;
      //   match_merge_object['params']['definitions'][match_merge_object_index]['alias'] = ele.formField.alias;
      //   match_merge_object['params']['definitions'][match_merge_object_index]['sample_view'] =
      //     ele.formField.sample_view;
      //   match_merge_object['params']['definitions'][match_merge_object_index]['primary_key'] = 'unique_id';

      //   const ungroup =
      //     'mergeManager' in ele
      //       ? ele?.mergeManager
      //           .filter((item) => item.select_grouping === 'Ungroup')
      //           .map((ele) => ({ identifier_key: ele.unique_id, reviewed_by: ele.reviewed_by }))
      //       : [];

      //   const regroup =
      //     'mergeManager' in ele
      //       ? ele?.mergeManager
      //           .filter((item) => item.select_grouping === 'Regroup')
      //           .map((ele) => ({
      //             identifier_key: ele.unique_id,
      //             reviewed_by: ele.reviewed_by,
      //             group: ele.group,
      //           }))
      //       : [];

      //   match_merge_object['params']['definitions'][match_merge_object_index]['edited_values'] = ele.dataManager ?? [];
      //   match_merge_object['params']['definitions'][match_merge_object_index]['ungroup'] = ungroup;
      //   match_merge_object['params']['definitions'][match_merge_object_index]['regroup'] = regroup;

      //   stepCount++;
      //   match_merge_object_index++;
      //   steps.push(match_merge_object);
      //   previous = true;
      // }
      else if (ele.nodeName === 'Customer Segmentation' || ele.nodeName === 'Plot') {
        let customer_seg_object_index = 0;
        const customer_seg_object = new Object();

        const fieldsList = ele.fields.map((item) =>
          item.operation === 'cohort_analysis'
            ? { operation: item.operation, date: item.xAxis, identifier: item.yAxis, value: item.zAxis }
            : item.operation === 'market_basket_analysis'
            ? { operation: item.operation, identifier: item.xAxis, item: item.yAxis }
            : item
        );

        customer_seg_object['method_name'] = 'CustomerSegmentation';
        customer_seg_object['params'] = new Object();
        customer_seg_object['params']['definitions'] = new Array();

        customer_seg_object['params']['definitions'][customer_seg_object_index] = new Object();
        customer_seg_object['params']['definitions'][customer_seg_object_index][
          'step_name'
        ] = `CustomerSegmentation${stepCount}`;
        customer_seg_object['params']['definitions'][customer_seg_object_index]['step_number'] = stepCount;
        customer_seg_object['params']['definitions'][customer_seg_object_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        customer_seg_object['params']['definitions'][customer_seg_object_index]['df'] = ele.formField.df;
        customer_seg_object['params']['definitions'][customer_seg_object_index]['alias'] = ele.formField.alias;
        customer_seg_object['params']['definitions'][customer_seg_object_index]['sample_view'] =
          ele.formField.sample_view;
        customer_seg_object['params']['definitions'][customer_seg_object_index]['persist'] = ele.formField.persist;
        customer_seg_object['params']['definitions'][customer_seg_object_index]['persist_type'] =
          ele.formField.persist_type;
        customer_seg_object['params']['definitions'][customer_seg_object_index]['distinct_rows'] =
          ele.formField.distinct_rows;
        customer_seg_object['params']['definitions'][customer_seg_object_index]['fields'] = fieldsList;
        customer_seg_object['params']['definitions'][customer_seg_object_index]['action'] = ele.formField.action
          ? ele.formField.action
          : '';
        stepCount++;
        customer_seg_object_index++;
        steps.push(customer_seg_object);
        previous = true;
      } else if (ele.nodeName === 'Visualization') {
        let customer_seg_object_index = 0;
        const customer_seg_object = new Object();

        const fieldsList = ele.fields.map((item) =>
          item.operation === 'cohort_analysis'
            ? { operation: item.operation, date: item.xAxis, identifier: item.yAxis, value: item.zAxis }
            : item.operation === 'market_basket_analysis'
            ? { operation: item.operation, identifier: item.xAxis, item: item.yAxis }
            : item
        );

        customer_seg_object['method_name'] = ele.nodeName;
        customer_seg_object['params'] = new Object();
        customer_seg_object['params']['definitions'] = new Array();

        customer_seg_object['params']['definitions'][customer_seg_object_index] = new Object();
        customer_seg_object['params']['definitions'][customer_seg_object_index][
          'step_name'
        ] = `${ele.nodeName}${stepCount}`;
        customer_seg_object['params']['definitions'][customer_seg_object_index]['step_number'] = stepCount;
        customer_seg_object['params']['definitions'][customer_seg_object_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        customer_seg_object['params']['definitions'][customer_seg_object_index]['df'] = ele.formField.df;
        customer_seg_object['params']['definitions'][customer_seg_object_index]['alias'] = ele.formField.alias;
        customer_seg_object['params']['definitions'][customer_seg_object_index]['sample_view'] =
          ele.formField.sample_view;
        customer_seg_object['params']['definitions'][customer_seg_object_index]['persist'] = ele.formField.persist;
        customer_seg_object['params']['definitions'][customer_seg_object_index]['persist_type'] =
          ele.formField.persist_type;
        customer_seg_object['params']['definitions'][customer_seg_object_index]['distinct_rows'] =
          ele.formField.distinct_rows;
        customer_seg_object['params']['definitions'][customer_seg_object_index]['fields'] = fieldsList;
        customer_seg_object['params']['definitions'][customer_seg_object_index]['action'] = ele.formField.action
          ? ele.formField.action
          : '';
        stepCount++;
        customer_seg_object_index++;
        steps.push(customer_seg_object);
        previous = true;
      } else if (ele.nodeName === 'C360') {
        // console.log()
      } else if (ele.nodeName === 'Ingestion Write') {
        const write_object = new Object();
        write_object['method_name'] = 'Write';

        write_object['params'] = new Object();

        const df_write = [];
        ele.sorting.forEach((data) => {
          const columns = getColumnList(data.dataFrame, getJobFromLocalStorage);
          const item = {
            step_name: `Write_${stepCount}`,
            step_number: stepCount,
            format: data.format,
            overwrite: data.overwrite,
            df: data.dataFrame,
            alias: ele.formField.alias,
            distinct_rows: data.distinct_rows,
            path: data.file_path,
            node_id: `${ele.nodeId}__${workflow_id}`,
            sample_view: ele.formField.sample_view,
            target: AWS_CONFIG_TYPE ? 's3' : 'adls',
            definitions: columns.toString(),
          };

          df_write.push(item);
          stepCount++;
        });

        write_object['params']['definitions'] = df_write;

        stepCount++;
        steps.push(write_object);
        previous = true;
      } else if (ele.nodeName === 'Analysis') {
        return null;
      } else if (ele.nodeName === 'Dedupe') {
        if (previous) {
          cluster_object_boolean = false;
          cluster_boolean = true;
          cluster_object_arr = [];
          cluster_object_index = 0;
        }
        if (cluster_object_boolean === false) {
          cluster_object = new Object();
          cluster_object['method_name'] = ele.nodeName;
          cluster_object['params'] = new Object();
          cluster_object['params']['definitions'] = new Array();
          cluster_object_boolean = true;
        }
        cluster_object['params']['definitions'][cluster_object_index] = new Object();
        cluster_object['params']['definitions'][cluster_object_index]['step_name'] = `${ele.step_name}_${stepCount}`;
        cluster_object['params']['definitions'][cluster_object_index]['step_number'] = stepCount;
        cluster_object['params']['definitions'][cluster_object_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        cluster_object['params']['definitions'][cluster_object_index]['alias'] = ele.formField.alias;
        cluster_object['params']['definitions'][cluster_object_index]['df'] = ele.formField.df;
        cluster_object['params']['definitions'][cluster_object_index]['unique_id'] = ele.uniqueId;
        const order_columns = ele.selectedColumnName.filter((column) => column !== ele.uniqueId);
        cluster_object['params']['definitions'][cluster_object_index]['order_columns'] = order_columns;
        const { configData } = ele;
        const col_threshold = configData.reduce((acc, cur) => {
          const { column, matchingCriteria, threshold } = cur;
          acc[column] = `${matchingCriteria}${threshold ? `,${threshold}` : ''}`;
          return acc;
        }, {});
        cluster_object['params']['definitions'][cluster_object_index]['col_threshold'] = col_threshold;
        cluster_object['params']['definitions'][cluster_object_index]['df'] = ele.formField.df;

        cluster_object_index++;
        cluster_object_arr.push(cluster_object);
        if (cluster_boolean) {
          steps.push(cluster_object_arr[0]);
          cluster_boolean = false;
        }
        stepCount++;
        previous = true;
      } else if (ele.nodeName === 'Segment') {
        if (previous) {
          segmentation_object_boolean = false;
          segmentation_boolean = true;
          segmentation_object_arr = [];
          segmentation_object_index = 0;
        }
        if (segmentation_object_boolean === false) {
          segmentation_object = new Object();
          segmentation_object['method_name'] = ele.nodeName;
          segmentation_object['params'] = new Object();
          segmentation_object['params']['definitions'] = new Array();
          segmentation_object_boolean = true;
        }
        segmentation_object['params']['definitions'][segmentation_object_index] = new Object();
        segmentation_object['params']['definitions'][segmentation_object_index][
          'step_name'
        ] = `${ele.step_name}_${stepCount}`;
        segmentation_object['params']['definitions'][segmentation_object_index]['alias'] = ele.formField.alias;
        segmentation_object['params']['definitions'][segmentation_object_index]['step_number'] = stepCount;
        segmentation_object['params']['definitions'][segmentation_object_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        segmentation_object['params']['definitions'][segmentation_object_index]['seed'] = ele.formField.seed;
        segmentation_object['params']['definitions'][segmentation_object_index]['alias'] = ele.formField.alias;
        segmentation_object['params']['definitions'][segmentation_object_index]['df'] = ele.formField.df;
        segmentation_object['params']['definitions'][segmentation_object_index]['train_ratio'] =
          ele.formField.trainRatio;
        segmentation_object['params']['definitions'][segmentation_object_index][
          'token'
        ] = `${ele.formField.algo_type}-${ele.formField.algorithm}`;
        const { algo_type } = ele.formField;
        const { algorithm } = ele.formField;
        // segmentation_object['params']['definitions'][segmentation_object_index]['algo_type'] = ele.formField.algo_type;
        if (algo_type === 'classification' && algorithm === 'Xgboost') {
          segmentation_object['params']['definitions'][segmentation_object_index]['algo_type'] = {
            [algo_type]: {
              [algorithm]: {
                xgb_params: {
                  maxDepth: ele.formField.maxDepth,
                  min_child_weight: ele.formField.minChildWeight,
                  gamma: ele.formField.gamma,
                  subsample: ele.formField.subsample,
                  colsample_by_tree: ele.formField.colsampleByTree,
                },
              },
            },
          };
        } else if (algo_type === 'classification' && algorithm === 'DecisionTree') {
          segmentation_object['params']['definitions'][segmentation_object_index]['algo_type'] = {
            [algo_type]: {
              [algorithm]: {},
            },
          };
        } else if (algo_type === 'clustering') {
          segmentation_object['params']['definitions'][segmentation_object_index]['algo_type'] = {
            [algo_type]: {
              [algorithm]: {
                KMeans_params: {
                  k: ele.formField.k,
                },
              },
            },
          };
        }
        segmentation_object['params']['definitions'][segmentation_object_index]['table_name'] = ele.formField.df;
        segmentation_object['params']['definitions'][segmentation_object_index]['modal_path'] =
          ele.formField.model_path;
        segmentation_object['params']['definitions'][segmentation_object_index]['pipeline_path'] =
          ele.formField.pipeline_path;
        const headerValues = ele.headerName.map((column) => column.header);
        segmentation_object['params']['definitions'][segmentation_object_index]['columns_to_encode'] = headerValues;
        // Filter feature columns
        const featureColumns = ele.headerName
          .filter((column) => column.col_type !== 'target Col')
          .map((column) => column.header);

        // Filter target columns
        const targetColumns = ele.headerName
          .filter((column) => column.col_type === 'target Col')
          .map((column) => column.header);
        segmentation_object['params']['definitions'][segmentation_object_index]['feature_columns'] = featureColumns;
        segmentation_object['params']['definitions'][segmentation_object_index]['target_columns'] = targetColumns[0];

        segmentation_object_index++;
        segmentation_object_arr.push(segmentation_object);
        if (segmentation_boolean) {
          steps.push(segmentation_object_arr[0]);
          segmentation_boolean = false;
        }
        stepCount++;
        previous = true;
      } else if (ele.nodeName === 'Prediction') {
        if (previous) {
          prediction_object_boolean = false;
          prediction_boolean = true;
          prediction_object_arr = [];
          prediction_object_index = 0;
        }
        if (prediction_object_boolean === false) {
          prediction_object = new Object();
          prediction_object['method_name'] = ele.nodeName;
          prediction_object['params'] = new Object();
          prediction_object['params']['definitions'] = new Array();
          prediction_object_boolean = true;
        }
        prediction_object['params']['definitions'][prediction_object_index] = new Object();
        prediction_object['params']['definitions'][prediction_object_index][
          'step_name'
        ] = `${ele.step_name}_${stepCount}`;
        prediction_object['params']['definitions'][prediction_object_index]['alias'] = ele.formField.alias;
        prediction_object['params']['definitions'][prediction_object_index]['step_number'] = stepCount;
        prediction_object['params']['definitions'][prediction_object_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        prediction_object['params']['definitions'][prediction_object_index]['alias'] = ele.formField.alias;
        prediction_object['params']['definitions'][prediction_object_index]['df'] = ele.formField.df;
        prediction_object['params']['definitions'][prediction_object_index]['algo_type'] = ele.formField.algo_type;
        prediction_object['params']['definitions'][prediction_object_index]['algorithm'] = ele.formField.algorithm;
        prediction_object['params']['definitions'][prediction_object_index][
          'token'
        ] = `${ele.formField.algo_type}-${ele.formField.algorithm}`;

        prediction_object['params']['definitions'][prediction_object_index]['table_name'] =
          ele.formField.df.toLowerCase() === 'dedupe' ? ele.formField.tablename : '';

        prediction_object['params']['definitions'][prediction_object_index]['modal_path'] = ele.formField.model_path;
        // prediction_object['params']['definitions'][prediction_object_index]['pipeline_path'] =
        //   ele.formField.pipeline_path;
        // const headerValues = ele.headerName.map((column) => column.header);
        // prediction_object['params']['definitions'][prediction_object_index]['columns_to_encode'] = headerValues;
        // Filter feature columns
        // const featureColumns = ele.headerName
        //   .filter((column) => column.col_type !== 'target Col')
        //   .map((column) => column.header);

        // Filter target columns
        // const targetColumns = ele.headerName
        //   .filter((column) => column.col_type === 'target Col')
        //   .map((column) => column.header);
        // prediction_object['params']['definitions'][prediction_object_index]['feature_columns'] = featureColumns;
        // prediction_object['params']['definitions'][prediction_object_index]['target_columns'] = targetColumns[0];

        prediction_object_index++;
        prediction_object_arr.push(prediction_object);
        if (prediction_boolean) {
          steps.push(prediction_object_arr[0]);
          prediction_boolean = false;
        }
        stepCount++;
        previous = true;
      } else if (
        ele.nodeName === DATA_QUALITY_RULES.nodeModalTitle ||
        ele.nodeName === DATA_QUALITY_RULES2.nodeModalTitle
      ) {
        // Tab 1
        if (previous) {
          cluster_object_boolean = false;
          cluster_boolean = true;
          cluster_object_arr = [];
          cluster_object_index = 0;
        }
        if (cluster_object_boolean === false) {
          cluster_object = new Object();
          cluster_object['method_name'] = 'Dedupe';
          cluster_object['params'] = new Object();
          cluster_object['params']['definitions'] = new Array();
          cluster_object_boolean = true;
        }
        cluster_object['params']['definitions'][cluster_object_index] = new Object();
        cluster_object['params']['definitions'][cluster_object_index]['step_name'] = `Dedupe_${stepCount}`;
        cluster_object['params']['definitions'][cluster_object_index]['step_number'] = stepCount;
        cluster_object['params']['definitions'][cluster_object_index]['node_id'] = `${ele.nodeId}__${workflow_id}`;
        cluster_object['params']['definitions'][cluster_object_index]['alias'] = ele.formField.alias;
        cluster_object['params']['definitions'][cluster_object_index]['df'] = ele.formField.df;
        cluster_object['params']['definitions'][cluster_object_index]['unique_id'] = ele.uniqueId;
        const order_columns = ele.selectedColumnName.filter((column) => column !== ele.uniqueId);
        cluster_object['params']['definitions'][cluster_object_index]['order_columns'] = order_columns;
        const { configData } = ele;
        const col_threshold = configData.reduce((acc, cur) => {
          const { column, matchingCriteria, threshold } = cur;
          acc[column] = `${matchingCriteria}${threshold ? `,${threshold}` : ''}`;
          return acc;
        }, {});
        cluster_object['params']['definitions'][cluster_object_index]['col_threshold'] = col_threshold;
        cluster_object['params']['definitions'][cluster_object_index]['df'] = ele.formField.df;

        cluster_object_index++;
        cluster_object_arr.push(cluster_object);
        if (cluster_boolean) {
          steps.push(cluster_object_arr[0]);
          cluster_boolean = false;
        }
        stepCount++;
        previous = true;

        // Tab 2

        const validation_object = new Object();
        let validation_object_index = 0;

        validation_object['method_name'] = 'DataValidation';
        validation_object['params'] = new Object();
        validation_object['params']['definitions'] = new Array();
        validation_object['params']['definitions'][validation_object_index] = new Object();
        validation_object['params']['definitions'][validation_object_index]['step_name'] = `Validate_${stepCount}`;
        validation_object['params']['definitions'][validation_object_index]['step_number'] = stepCount;
        validation_object['params']['definitions'][validation_object_index]['df'] = ele.formField.df;
        validation_object['params']['definitions'][validation_object_index]['alias'] = ele.formField.alias;
        validation_object['params']['definitions'][validation_object_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;
        validation_object['params']['definitions'][validation_object_index]['sample_view'] = ele.formField.sample_view;
        validation_object['params']['definitions'][validation_object_index]['persist'] = ele.formField.persist;
        validation_object['params']['definitions'][validation_object_index]['persist_type'] =
          ele.formField.persist_type;
        validation_object['params']['definitions'][validation_object_index]['action'] = ele.formField.action;
        validation_object['params']['definitions'][validation_object_index]['path_validation'] = ele.formField.path;
        validation_object['params']['definitions'][validation_object_index]['path_profiling'] =
          ele.formField.profilingPath;

        const expectations_details = [];
        const newCol = [...ele.columnName];

        newCol.map((item) => {
          if (item.validation_name !== '') {
            const data = {
              expectation_name: item.validation_name,
              column: item.column,
            };

            delete item['validation_name'];
            delete item['column'];

            let param;

            if (data.expectation_name === 'expect_column_values_to_be_between') {
              param = {
                expectation_name: data.expectation_name,
                args: {
                  column: data.column,
                  max_value: parseInt(item.max_value, 10),
                  min_value: parseInt(item.min_value, 10),
                },
              };
            } else if (data.expectation_name === 'expect_column_values_to_be_in_set') {
              param = {
                expectation_name: data.expectation_name,
                args: {
                  column: data.column,
                  value_set: item.value_set.split(','),
                },
              };
            } else {
              param = {
                expectation_name: data.expectation_name,
                args: { column: data.column, ...item },
              };
            }

            expectations_details.push(param);
          }
        });

        validation_object['params']['definitions'][validation_object_index]['expectations_details'] =
          expectations_details;

        steps.push(validation_object);
        stepCount++;
        validation_object_index++;
        previous = true;

        // Tab 3

        const rules_selector_index = 0;
        const rules_selector_object = new Object();
        rules_selector_object['method_name'] =
          ele.nodeName === DATA_QUALITY_RULES2.nodeModalTitle ? 'RuleSelectorNew' : 'RuleSelector';
        rules_selector_object['params'] = new Object();
        rules_selector_object['params']['definitions'] = new Array();

        rules_selector_object['params']['definitions'][rules_selector_index] = new Object();
        rules_selector_object['params']['definitions'][rules_selector_index]['step_name'] = `RuleSelector_${stepCount}`;
        rules_selector_object['params']['definitions'][rules_selector_index]['step_number'] = stepCount;
        rules_selector_object['params']['definitions'][rules_selector_index]['df'] = ele.formField.df;

        rules_selector_object['params']['definitions'][rules_selector_index]['alias'] = ele.formField.alias;
        rules_selector_object['params']['definitions'][rules_selector_index]['format'] = ele.formField.format;
        rules_selector_object['params']['definitions'][rules_selector_index]['path'] = ele.formField.innerPath;

        rules_selector_object['params']['definitions'][rules_selector_index][
          'node_id'
        ] = `${ele.nodeId}__${workflow_id}`;

        rules_selector_object['params']['definitions'][rules_selector_index]['distinct_rows'] =
          ele.formField.distinct_rows;
        rules_selector_object['params']['definitions'][rules_selector_index]['sample_view'] = ele.formField.sample_view;

        rules_selector_object['params']['definitions'][rules_selector_index]['action'] = ele.formField.action
          ? ele.formField.action
          : '';

        const rule_list = [];

        if (ele.nodeName === DATA_QUALITY_RULES2.nodeModalTitle) {
          if (ele.formField.rule_list.length > 0) {
            ele.formField.rule_list.forEach((el) => {
              if (el.checked && el.metric && el.format && el.field_name && el.unit) {
                rule_list.push({ format: el.format, field_name: el.field_name, unit: el.unit, metric: el.metric });
              }
            });
          }
          ele.formField.configDataNew.forEach((el) => {
            if (el.statement && el.field_name && el.dataType && el.metric) {
              rule_list.push({
                format: el.statement,
                field_name: el.field_name,
                unit: el.dataType,
                metric: el.metric,
              });
            }
          });
          if (ele.formField.configData.length > 0) {
            ele.formField.configData.forEach((el) => {
              if (el.statement && el.field_name && el.dataType && el.metric) {
                rule_list.push({
                  format: el.statement,
                  field_name: el.field_name,
                  unit: el.dataType,
                  metric: el.metric,
                });
              }
            });
          }
        } else {
          if (ele.formField.rule_list.length > 0) {
            ele.formField.rule_list.forEach((el) => {
              if (el.checked && el.format && el.field_name && el.unit) {
                rule_list.push({ format: el.format, field_name: el.field_name, unit: el.unit });
              }
            });
          }

          if (ele.formField.configData.length > 0) {
            ele.formField.configData.forEach((el) => {
              if (el.statement && el.field_name && el.dataType) {
                rule_list.push({ format: el.statement, field_name: el.field_name, unit: el.dataType });
              }
            });
          }
        }

        rules_selector_object['params']['definitions'][rules_selector_index]['rule_list'] = rule_list;

        rules_selector_object['params']['definitions'][rules_selector_index]['action'] = ele.formField.action
          ? ele.formField.action
          : '';

        stepCount++;
        steps.push(rules_selector_object);
        previous = true;
      } else if (ele.nodeName === 'RFM') {
        const RfmObject = new Object();
        RfmObject['method_name'] = 'RFMAnalysis';
        RfmObject['params'] = new Object();
        RfmObject['params']['definitions'] = new Array();

        const item = {
          step_name: `${ele.step_name}_${stepCount}`,
          step_number: stepCount,
          df: ele.formField.df,
          format: ele.formField.format,
          node_id: `${ele.nodeId}__${workflow_id}`,
          alias: ele.formField.alias,
          distinct_rows: ele.formField.distinct_rows,
          sample_view: ele.formField.sample_view,
          action: ele.formField.action,
          recency_column: ele.formField.recency_column,
          frequency_column: ele.formField.frequency_column,
          revenue_column: ele.formField.revenue_column,
        };
        RfmObject['params']['definitions'].push(item);
        stepCount++;
        steps.push(RfmObject);
        previous = true;
      } else if (SKIPPED_BLOCKS[ele.nodeName]) {
        // skipped this block
      } else {
        const multiJoin_object = new Object();
        multiJoin_object['method_name'] = 'MultiTableJoin';
        multiJoin_object['params'] = new Object();
        multiJoin_object['params']['step_name'] = `${ele.step_name}_${stepCount}`;
        multiJoin_object['params']['step_number'] = stepCount;
        multiJoin_object['params']['df'] = ele.formField.alias;
        multiJoin_object['params']['node_id'] = `${ele.nodeId}__${workflow_id}`;
        multiJoin_object['params']['join_condition'] = ele.formField.join_conditions;
        multiJoin_object['params']['select_cols'] = ele.formField.select_cols;
        multiJoin_object['params']['join_filter'] = ele.formField.join_filter ? ele.formField.join_filter : '';
        multiJoin_object['params']['persist'] = ele.formField.persist;
        multiJoin_object['params']['distinct_rows'] = ele.formField.distinct_rows;
        multiJoin_object['params']['sample_view'] = ele.formField.sample_view;
        if (ele.formField.persist === true) {
          multiJoin_object['params']['persist_type'] = ele.formField.persist_type;
        } else {
          multiJoin_object['params']['persist_type'] = '';
        }
        multiJoin_object['params']['tables'] = new Object();

        // json was breaking as tables was null
        const tableLength =
          ele.formField.tables === null || ele.formField.tables === undefined
            ? 0
            : Object.keys(ele?.formField?.tables).length;
        for (let i = 1; i <= tableLength; i++) {
          multiJoin_object['params']['tables'][`table${i}`] = ele.formField.tables[`table${i}`];
        }

        multiJoin_object['params']['joins'] = new Object();

        // json was breaking as joins was null
        const joinLength =
          ele.formField.joins === null || ele.formField.joins === undefined
            ? 0
            : Object.keys(ele.formField.joins).length;

        for (let j = 1; j <= joinLength; j++) {
          multiJoin_object['params']['joins'][`join${j}`] = ele.formField.joins[`join${j}`];
        }

        multiJoin_object['params']['action'] = ele.formField.action ? ele.formField.action : '';

        stepCount++;
        steps.push(multiJoin_object);
        previous = true;
      }
    });

  // steps.push(read_object_arr[0]);
  // steps.push(execute_sql_object_arr[0]);

  const main = {
    // name: '',
    // transformer_execution_details: {},
    // spark_config: {},
    // udf: {},
    steps,
  };

  return main;
}

const getColumnList = (dataFrame, localStorageData) => {
  const columns = [];
  localStorageData.forEach((el) => {
    if (el.formField.alias === dataFrame) {
      el.fetchedHeader.forEach((ele) => {
        columns.push(ele.header);
      });
    }
  });

  return columns;
};
